var tagalogTranslation = {
    translations: {
        philSysID: "PhilSys ID",
        iBP: "Integrated Bar of the Philippines (IBP)",
        philippinePassport: "Pasaporte ng Pilipinas",
        driversLicense: "Lisensya sa Pagmamaneho",
        seamanBook: "Libro ng Seaman",
        loading: "Naglo-load...",
        loadingDataProvider: "Naglo-load ng tagapagbigay ng datos...",
        tallySheetImport: {
            title: "Mga import ng tally sheet",
            subtitle: "Mag-import ng ES&S o CSV tally sheet files, i-preview ang nabuong ballot boxes, at aprubahan ang mga ito bago gumawa ng tally sheets.",
            createTitle: "I-import ang mga tally sheet",
            detailTitle: "Import ng tally sheet",
            empty: "Wala pang mga import ng tally sheet.",
            emptyBody: "Magsimula sa pag-import ng ES&S Enhanced XML o canonical CSV file para sa kaganapan ng halalan na ito.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "Canonical CSV",
            },
            channel: {
                PAPER: "Papel",
                POSTAL: "Koreo",
                IN_PERSON: "Personal",
            },
            table: {
                created: "Nilikha",
                createdBy: "Ginawa ni",
                file: "File",
                format: "Format",
                channel: "Channel",
                status: "Katayuan",
                labels: "Mga Label",
                annotations: "Mga Anotasyon",
                actions: "Mga Aksyon",
            },
            summary: {
                imported: "Na-import",
                changed: "Nabago",
                new: "Bago",
                unchanged: "Walang pagbabago",
                conflicted: "May Salungatan",
                errors: "Mga Error",
            },
            status: {
                PENDING_REVIEW: "Naghihintay ng Review",
                APPROVED: "Inaprubahan",
                DISAPPROVED: "Hindi Inaprubahan",
                FAILED_VALIDATION: "Nabigo ang Validation",
                CONFLICTED: "May Salungatan",
                NEW: "Bago",
                CHANGED: "Nabago",
                UNCHANGED: "Walang pagbabago",
            },
            fields: {
                format: "Format",
                channel: "Channel",
                supportedFormats: "Mga suportadong format: XML, CSV",
                generatedTallySheet: "Nabuong tally sheet",
                sourceCandidates: "Mga source candidate ID",
                none: "Wala",
            },
            actions: {
                create: "I-import ang mga tally sheet",
                review: "I-review",
                source: "Pinagmulan",
                cancel: "I-cancel",
                preview: "I-preview",
                save: "I-save ang import",
                approve: "Aprubahan",
                disapprove: "Hindi aprubahan",
                close: "Isara",
                openExisting: "Buksan ang umiiral na",
            },
            notifications: {
                selectFile: "Pumili ng import file bago ito i-preview",
                duplicateSource: "Ang hash ng source file na ito ay lumitaw na sa isang naunang import ng tally sheet.",
                uploadUrlError: "Hindi makagawa ng upload URL",
                uploadError: "Hindi ma-upload ang import file",
                previewEmpty: "Walang laman ang sagot ng preview",
                previewError: "Hindi ma-preview ang import",
                importEmpty: "Walang laman ang sagot ng import",
                created: "Nagawa ang import ng tally sheet",
                createError: "Hindi magawa ang import",
                reviewEmpty: "Walang laman ang sagot ng review",
                conflicted: "May lumang baseline conflicts ang import",
                approved: "Inaprubahan ang import",
                disapproved: "Hindi inaprubahan ang import",
                reviewError: "Hindi ma-review ang import",
                sourceUrlError: "Hindi makagawa ng source download URL",
                sourceDownloadError: "Hindi ma-download ang source file",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} ng {{total}}",
                previous: "Nakaraan",
                next: "Susunod",
            },
        },
        reconciliation: {
            menuButton: "I-sync ang ext. botante",
            categories: {
                VOTED_INTERNET: "Bumoto sa pamamagitan ng Internet",
                VOTED_OTHER_CHANNEL: "Bumoto sa ibang channel",
                DISABLED_DELETE_CALL: "Na-disable ang botante",
                DELETION_REVERTED: "Na-revert ang pagtanggal",
                PROFILE_UPDATE: "Na-update ang profile",
                VOTER_ADDED: "Naidagdag ang botante",
                REENABLED: "Na-enable muli ang botante",
                VOTED_UNMARKED: "Inalis ang markang bumoto ang botante",
                ROW_FAILURE: "Nabigo ang row",
            },
            table: {
                voterId: "ID ng Botante",
                field: "Field",
                category: "Kategorya",
                currentValue: "Kasalukuyang value",
                newValue: "Bagong value",
                reason: "Dahilan",
                rowLabel: "Row",
                noDifferences: "Walang nakitang pagkakaiba - naka-sync na ang mga sistema.",
            },
            wizard: {
                title: "Pag-sync ng External Reconciliation",
                subtitle: "I-sync ang listahan ng botante sa external system",
                drop: {
                    description: "I-drop ang reconciliation file na ginawa ng external system - awtomatikong kinakalkula at ipinapakita sa magkahiwalay na tables ang parehong diffs (external side at Sequent side).",
                    fileFormatLabel: "CSV file",
                    uploading: "Ina-upload ang {{fileName}} at kinakalkula ang parehong diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Sequence {{sequence}}, ginawa noong {{generatedAt}}",
                    rowFailuresWarning: "Hindi ligtas na ma-reconcile ang {{count}} row(s) at hindi kasama ang mga ito sa parehong diffs - tingnan ang mga detalye sa ibaba.",
                    noDifferences: "Walang pagkakaiba - naka-sync na ang dalawang sistema.",
                    diffOnlyDifferences: "Convergence check ito para sa nailapat nang Sequence. Ipinapakita ang mga pagkakaiba para sa follow-up, ngunit hindi na maaaring ilapat muli ang round na ito.",
                    externalDiffTitle: "External diff",
                    sequentDiffTitle: "Sequent diff",
                    downloadExternalPatch: "I-download ang external patch",
                    externalDiffCaption: "I-download ang patch at ibigay ito sa external system sa labas ng tool na ito. Kapag na-apply na nito ang patch at nagawa ang susunod na reconciliation file, i-click ang 'Bumalik' at i-drop ang file na iyon - mag-e-enable ang 'I-apply' kapag walang laman ang table na ito.",
                    noExternalDifferences: "Walang pagkakaiba sa external side.",
                    sequentDiffCaption: "I-apply ang mga pagbabago nang direkta sa Sequent sa pamamagitan ng pag-click sa 'I-apply' - walang ginagawang patch file para dito.",
                    noSequentDifferences: "Walang pagkakaiba sa Sequent side.",
                },
                applying: {
                    inProgress: "Inilalapat ang mga pagbabago sa Sequent side...",
                    rowFailures: "Hindi kasama ang {{count}} row(s) sa round na ito at kailangan ng manual na follow-up - tingnan ang mga detalye sa ibaba.",
                    rowFailuresTruncated: "Ipinapakita ang unang {{shown}} sa {{count}} row failure. Ayusin ang magkakaparehong sanhi at subukang muli upang makita ang mga natitirang failure.",
                    success: "Matagumpay na nailapat ang lahat ng pagbabago sa Sequent side.",
                },
                actions: {
                    cancel: "I-cancel",
                    back: "Bumalik",
                    apply: "I-apply",
                    next: "Susunod",
                    startOver: "Ulitin mula sa simula",
                    close: "Isara",
                },
                confirm: {
                    title: "Kumpirmahin ang mga pagbabago sa reconciliation",
                    categoriesNote: "Ang mga kategoryang naka-highlight sa orange ({{categories}}) ay nakakaapekto sa status ng pagboto o nagdi-disable ng mga botante.",
                    applyChanges: "I-apply ang mga pagbabago",
                    continue: "Magpatuloy",
                },
                summary: {
                    votedOtherChannel: "mina-mark ang {{count}} botante bilang bumoto sa ibang channel",
                    disabled: "dini-disable ang {{count}} botante",
                    reenabled: "ine-enable muli ang {{count}} botante",
                    votedUnmarked: "inaalis ang markang bumoto sa {{count}} botante",
                    profileUpdated: "ina-update ang {{count}} profile",
                    voterAdded: "nagdadagdag ng {{count}} botante",
                    prefix: "Ilalapat nito ang mga pagbabagong {{parts}}.",
                    empty: "Walang pagbabago sa Sequent side na ila-apply.",
                },
                notifications: {
                    envelopeLoadError: "Hindi na-load ang reconciliation diff - subukan muli.",
                    generateFailed: "Hindi na-calculate ang reconciliation diff - tingnan ang task widget para sa detalye.",
                    applyFailed: "Hindi na-apply ang mga pagbabago sa Sequent side - tingnan ang task widget para sa detalye.",
                    uploadUrlError: "Hindi makakuha ng upload URL",
                    generateTaskError: "Hindi masimulan ang reconciliation diff task",
                    uploadError: "Hindi ma-upload ang reconciliation file",
                    applyTaskError: "Hindi masimulan ang apply task",
                    applyError: "Hindi na-apply ang mga pagbabago sa reconciliation",
                },
            },
        },
        logsScreen: {
            noPermissions: "Wala kang permiso upang ma-access ang mga log.",
            title: "Mga Log",
            subtitle: "Pangkalahatang mga log ng pangunahing at IAM na database",
            actions: {
                csv: "I-export sa CSV",
                pdf: "I-export sa PDF",
            },
            exportdialog: {
                description: "Pakikonpirma na nais mong isagawa ang aksyong ito, maaaring magtagal ito bago matapos.",
            },
            column: {
                id: "ID",
                statement_kind: "Uri ng Pahayag",
                created: "Nilikha",
                statement_timestamp: "Tatak ng Panahon ng Pahayag",
                message: "Mensahe",
                user_id: "ID ng User",
                username: "Username",
                sender_pk: "Primary Key ng Nagpadala",
                log_type: "Uri ng Log",
                event_type: "Uri ng Kaganapan",
                description: "Paglalarawan",
                version: "Bersyon",
            },
            main: {
                title: "Mga Log ng Pangunahing Database",
            },
            iam: {
                title: "Mga Log ng IAM Database",
            },
        },
        tasksScreen: {
            noPermissions: "Wala kang pahintulot na ma-access ang mga log.",
            title: "Pagpapatupad ng Mga Gawain",
            subtitle: "Impormasyon tungkol sa mga naisagawang gawain",
            taskInformation: "Impormasyon ng Gawain",
            status: "katayuan: {{status}}",
            ok: "Sige",
            column: {
                id: "Indeks",
                name: "Pangalan ng Gawain",
                type: "Uri",
                execution_status: "Katayuan",
                start_at: "Oras ng Pagsisimula",
                end_at: "Oras ng Pagtatapos",
                executed_by_user: "Tagapagpatupad",
                annotations: "Mga Anotasyon",
                labels: "Mga Label",
                logs: "Mga Log",
            },
            tasksExecution: {
                DELETE_TENANT: "Tanggalin ang tenant",
                PUBLISH_BALLOT: "I-publish ang balota",
                VOTER_INFORMATION_LETTER: "Liham ng impormasyon para sa botante",
                EXPORT_ELECTION_EVENT: "I-export ang Kaganapan sa Halalan",
                CREATE_ELECTION_EVENT: "Lumikha ng Kaganapan ng Halalan",
                IMPORT_ELECTION_EVENT: "I-import ang Kaganapan sa Halalan",
                IMPORT_USERS: "I-import ang mga Gumagamit",
                EDIT_USER: "I-edit ang Botante",
                IMPORT_CANDIDATES: "I-import ang mga Kandidato",
                EXPORT_VOTERS: "I-export ang mga botante",
                CREATE_TRANSMISSION_PACKAGE: "Lumikha ng Transmission Package",
                EXPORT_BALLOT_PUBLICATION: "I-export ang Paglalathala ng Balota",
                GENERATE_TRANSMISSION_REPORT: "Bumuo ng Ulat ng Paglilipat",
                EXPORT_ACTIVITY_LOGS_REPORT: "I-export ang Ulat ng Mga Log ng Aktibidad",
                GENERATE_REPORT: "Bumuo ng ulat",
                EXPORT_TRUSTEES: "I-export ang mga Awtoridad",
                EXPORT_APPLICATION: "I-export ang Mga Aplikasyon",
                EXPORT_TENANT_CONFIG: "I-export ang Configurasyon ng Tenant",
                IMPORT_TENANT_CONFIG: "I-import ang Configurasyon ng Tenant",
                RENDER_DOCUMENT_PDF: "I-render ang dokumento bilang PDF",
                CREATE_TENANT: "Lumikha ng Tenant",
                EXPORT_TEMPLATES: "I-export ang mga Template",
                IMPORT_TEMPLATES: "I-import ang mga Template",
                DELETE_ELECTION_EVENT: "Tanggalin ang Kaganapan ng Halalan",
                DELETE_VOTERS: "Tanggalin ang mga botante",
                PREPARE_PUBLICATION_PREVIEW: "Ihanda ang paunang tingin ng publikasyon",
                EXPORT_TALLY_RESULTS_XLSX: "I-export ang mga resulta ng pagbibilang sa format na XLSX",
                EXPORT_CERTIFICATE_AUTHORITIES: "I-export ang mga awtoridad sa sertipikasyon",
                PUBLISH_RESULTS_WEBSITE: "I-publish ang website ng mga resulta",
            },
            documentAccess: {
                title: "Pag-access sa dokumento",
                sensitivityNotice: "Sensitibong impormasyon. Ibahagi ang password na ito sa nilalayong tatanggap lamang.",
                passwordLabel: "Password para buksan ang naka-encrypt na PDF",
                showPassword: "Ipakita ang password",
                copyPassword: "Kopyahin ang password",
                passwordCopied: "Nakopya ang password",
                passwordError: "Hindi nakuha ang password ng PDF",
                copyError: "Hindi makopya ang password",
                guidance: "Nilo-load lamang ang password pagkatapos mong piliin ang Ipakita ang password. Kapag na-load na, lalabas dito ang read-only na field na may opsyong kumopya.",
            },
            widget: {
                taskTitle: "Gawain: {{title}}",
                viewTask: "Tingnan Ang Gawain",
                downloadDocument: "I-download ang File",
            },
            exportTasksExecution: {
                success: "Matagumpay na natapos ang pag-export",
                error: "Error sa pag-export ng Tasks Execution",
            },
        },
        areas: {
            common: {
                title: "Mga Lugar",
                subTitle: "Pag-configure ng lugar.",
                deleteError: "Error sa pagtanggal ng lugar",
            },
            createAreaSuccess: "Lugar na nalikha",
            updateAreaSuccess: "Na-update ang lugar",
            createAreaError: "Hindi makalikha ng Lugar",
            sequent_backend_area_contest: "Mga Paligsahan",
            empty: {
                header: "Wala pang Lugar.",
                action: "Lumikha ng Lugar",
            },
            formImputs: {
                allowEarlyVoting: "Payagan ang Maagang Pagboto",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Service account key ng Google Calendar",
                gapiEmail: "Email ng authentication sa Google Calendar",
            },
            errors: {
                invalidGapiKey: "Hindi wastong format ng Google Calendar Service Account Key",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Mga Link ng Tulong",
                logoUrl: "URL ng Logo",
                css: "Custom CSS",
            },
            errors: {
                invalidHelpLinks: "Hindi wastong format ng Mga Link ng Tulong",
            },
        },
        electionTypeScreen: {
            noPermissions: "Wala kang pahintulot na ma-access ang mga setting.",
            common: {
                title: "Uri ng Halalan",
                subtitle: "Pag-configure ng uri ng halalan",
                onlineVoting: "Online na Pagboto",
                kioskVoting: "Pagboto sa Kiosk",
                telephoneVoting: "Pagboto sa Telepono",
                settingTitle: "Mga Setting",
                settingSubtitle: "Pangkalahatang Pag-configure",
                sms: "SMS",
                mail: "Sulat",
                createNew: "Lumikha ng Uri ng Halalan",
                emptyHeader: "Wala pang Uri ng Halalan.",
                emptyBody: "Gusto mo bang lumikha ng isa?",
            },
            create: {
                title: "Lumikha ng Uri ng Halalan",
            },
            edit: {
                title: "I-edit ang Uri ng Halalan",
            },
            tabs: {
                votingChannels: "MGA CHANNEL NG PAGBOTO",
                electionTypes: "URI NG HALALAN",
                templates: "MGA TEMPLATE",
                languages: "WIKA",
                localization: "LOKALISASYON",
                integrations: "MGA INTEGRASYON",
                lookAndFeel: "PAGPASADYA KAN ITSURA",
                schedules: "NAISKEDYUL NA MGA KAGANAPAN",
                trustees: "TAGAPANGALAGA",
                BackupRestore: "Backup / Ibalik",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Wala pang mga tagapangasiwa.",
                createNew: "Lumikha ng Tagapangasiwa",
                title: "Tagapangasiwa",
                subtitle: "Konpigurasyon ng Tagapangasiwa",
                emptyBody: "Gusto mo bang lumikha ng isa?",
            },
            create: {
                title: "Lumikha ng Tagapangasiwa",
            },
            edit: {
                title: "I-edit ang Tagapangasiwa",
            },
        },
        scheduleScreen: {
            noPermissions: "Wala kang pahintulot na ma-access ang mga setting.",
            createScheduleSuccess: "Nalikha ang iskedyul",
            createScheduleError: "Error sa paglikha ng iskedyul",
            deleteScheduleSuccess: "Naitanggal ang iskedyul",
            deleteScheduleError: "Error sa pagtanggal ng iskedyul",
            common: {
                title: "Naka-iskedyul",
                subtitle: "Pag-configure ng mga iskedyul",
                createNew: "Lumikha ng Iskedyul",
                emptyHeader: "Wala pang Iskedyul.",
                emptyBody: "Gusto mo bang lumikha ng isa?",
            },
            create: {
                title: "Lumikha ng Iskedyul",
                selectSchedule: "Pumili ng isang iskedyul mula sa predefined list o magsulat ng custom na iskedyul",
            },
            edit: {
                title: "I-edit ang Iskedyul",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Pag-lockdown ng sistema para sa pinal na pag-configure ng Internet voting settings",
                START_PRE_REGISTRATION_OVCS: "Pagsisimula at pagtatapos ng pre-registration para sa OVCS",
                END_PRE_REGISTRATION_OVCS: "Pagtatapos ng pre-registration para sa OVCS",
                START_TEST_VOTING_PERIOD: "Pagsisimula ng test voting period",
                END_TEST_VOTING_PERIOD: "Pagtatapos ng test voting period",
                START_INTERNET_VOTING_PERIOD: "Pagsisimula ng Internet voting period",
                END_INTERNET_VOTING_PERIOD: "Pagtatapos ng Internet voting period",
                LAB_TEST: "Lab test",
                FIELD_TEST: "Field test",
                MOCK_ELECTIONS: "Mga pagsubok na halalan",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Boto kada araw",
            votesOverTime: "Mga boto sa paglipas ng panahon",
            timeResolution: "Resolusyon ng oras",
            timeRange: "Saklaw ng oras",
            minute: "Minuto",
            hour: "Oras",
            day: "Araw",
            votersByChannels: "Mga botante ayon sa channel",
            voterLoginURL: "URL para sa Pag-login ng Botante",
            voterEnrollURL: "URL para sa Pag-enroll ng Botante",
            voterEnrollKioskURL: "Kiosk URL para sa Pag-enroll ng Botante",
            ipAddress: {
                emptyState: "Wala pang mga boto.",
                title: "Mga IP Address",
                ip: "IP",
                country: "Bansa",
                VoteCount: "Bilang ng boto",
                ElectionName: "Pangalan ng halalan",
                VotersId: "Mga Id ng mga botante",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Pag-configure ng kaganapan ng halalan.",
                showMore: "Lakihan ang nakikita",
                showLess: "Bawasan ang nakikita",
                adminPortal: "Admin Portal",
                allowPublishAfterLockdown: "Payagan lamang ang pag-publish ng kaganapan ng halalan pagkatapos ng lockdown",
                reset: "I-reset ang custom na filter",
            },
            edit: {
                general: "Pangkalahatan",
                dates: "Petsa",
                customUrls: "Pasadyang Unang Bahagi ng URL",
                votingPeriod: "Panahon ng Pagboto",
                language: "Wika",
                languageAndRegion: "Wika at Rehiyon",
                allowed: "Pinapayagang Mga Channel ng Pagboto",
                materials: "Mga Karagdagang Materyales",
                ballotDesign: "Disenyo ng Balota",
                templates: "Mga plantilya",
                reorder: "I-reorder ang mga halalan",
                advancedConfigurations: "Mga Advanced na Pag-configure",
                importCandidates: "Mag-import ng mga Kandidato",
                custom_filters: "Pasadyang mga filter",
                voter_authentication: "Pag-authenticate ng Botante",
                realm_attributes: "Mga katangian ng realm ng Keycloak",
                realm_attributes_load_error: "Error sa pag-load ng mga katangian ng realm ng Keycloak",
                realm_attributes_update_error: "Error sa pag-update ng mga katangian ng realm ng Keycloak",
                realm_attributes_not_loaded: "Hindi na-load ang mga katangian ng realm ng Keycloak; hindi na-save ang mga pagbabago",
                password_policy: "Patakaran sa password",
                password_policy_load_error: "Error sa pag-load ng patakaran sa password ng Keycloak",
                password_policy_update_error: "Error sa pag-update ng patakaran sa password ng Keycloak",
                password_policy_not_loaded: "Hindi na-load ang patakaran sa password ng Keycloak; hindi na-save ang mga pagbabago",
            },
            customUrls: {
                login: "Pag-login",
                enrollment: "Pag-enroll",
            },
            localization: {
                emptyHeader: "Walang nakatakdang wika para sa kaganapan",
                selectLanguage: "Pumili ng Wika",
                notify: {
                    success: "Matagumpay ang pag-update ng localization",
                    error: "Bigo ang pag-update ng localization",
                    duplicateKey: "May override na para sa key at saklaw ng portal na ito.",
                    invalidDateTimeFormat: "Di-wastong format ng petsa/oras. Gamitin ang mga token na yyyy, MM, dd, HH, mm, ss (hal. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localization",
                    subTitle: "Pag-configure ng localization",
                },
                labels: {
                    key: "Susi",
                    scope: "Saklaw ng portal",
                    value: "Halaga",
                },
                scopes: {
                    legacy: "Luma ({{portal}})",
                    global: "Pangkalahatan",
                    votingPortal: "Portal ng pagboto",
                    ballotVerifier: "Tagapagpatunay ng balota",
                    resultsPortal: "Portal ng mga resulta",
                    adminPortal: "Portal ng admin",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Pinakamababang haba",
                    maximumLength: "Pinakamataas na haba",
                    includeUppercase: "Magsama ng malalaking titik",
                    includeLowercase: "Magsama ng maliliit na titik",
                    includeDigits: "Magsama ng mga numero",
                    includeSpecialCharacters: "Magsama ng mga espesyal na karakter",
                    help: {
                        minimumLength: "Ang pinakamababang bilang ng mga karakter na kailangan para sa password.",
                        maximumLength: "Ang pinakamataas na bilang ng mga karakter na pinapayagan para sa password.",
                        includeUppercase: "Kailangan ng hindi bababa sa isang malaking titik sa password.",
                        includeLowercase: "Kailangan ng hindi bababa sa isang maliit na titik sa password.",
                        includeDigits: "Kailangan ng hindi bababa sa isang numero sa password.",
                        includeSpecialCharacters: "Kailangan ng hindi bababa sa isang espesyal na karakter sa password.",
                    },
                    notConfigured: "Walang naka-configure na patakaran sa password. Kapag nag-save, ilalapat ang mga default na halaga sa ibaba.",
                    errors: {
                        lengthRange: "Ang mga halaga ng haba ng password ay dapat mga buong numero mula 1 hanggang 256.",
                        minimumExceedsMaximum: "Hindi maaaring lumampas ang pinakamababang haba sa pinakamataas na haba.",
                        characterClassRequired: "Pumili ng hindi bababa sa isang klase ng karakter para sa password.",
                    },
                },
                name: "Pangalan",
                alias: "Alias",
                description: "Paglalarawan",
                startDateTime: "Petsa at Oras ng Pagsisimula",
                endDateTime: "Petsa at Oras ng Pagtatapos",
                language: "Wika",
                votingChannels: "Mga Channel ng Pagboto",
                materialActivated: "Mga Karagdagang Materyales na Gumagana",
                supportMaterialsPolicy: {
                    label: "Patakaran sa Mga Pangsuportang Materyales",
                    helperText: "Ang Kinakailangan para Bumoto ay nangangailangan sa mga botante na buksan ang bawat Pangsuportang Materyal at kumpirmahin na nabasa na nila ito bago sila makaboto.",
                    options: {
                        off: "Naka-off",
                        optional: "Opsyonal",
                        mandatory_for_voting: "Kinakailangan para Bumoto",
                    },
                },
                materialTitle: "Pamagat",
                materialSubTitle: "Subtitle",
                logoUrl: "URL ng Logo",
                userVerification: "Puede kang mag-introdusir nin sarong pasadyang plantilya na gagamiton tanganing mano-manong ma-verify an mga botante",
                redirectFinishUrl: "Redirect Finish URL",
                kioskRedirectFinishUrl: "URL ng Pag-redirect sa Pagtatapos ng Kiosk",
                css: "Custom CSS",
                skipElectionList: "Laktawan ang Screen ng Listahan ng Halalan",
                showUserProfile: "Ipakita ang Profile ng Gumagamit",
                showCastVoteLogs: {
                    policyLabel: "Patakaran sa Ipakita ng mga Log ng Pagboto",
                    options: {
                        "show-logs-tab": "Ipakita ang Tab ng mga Log ng Pagboto",
                        "hide-logs-tab": "Laktawan ang Tab ng mga Log ng Pagboto",
                    },
                },
                lockdownState: {
                    policyLabel: "Kalagayan ng Lockdown",
                    options: {
                        "locked-down": "Naka-lockdown",
                        "not-locked-down": "Hindi naka-lockdown",
                    },
                },
                decodedBallots: {
                    policyLabel: "Isama ang mga na-decode na balota sa database ng mga resulta",
                    options: { "included": "Isama", "not-included": "Huwag isama" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Isang Paligsahan",
                        "multiple-contests": "Maraming Paligsahan",
                    },
                    policyLabel: "Patakaran sa Pag-encode ng Paligsahan",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Format ng petsa at oras ng Voting Portal",
                    helperText: 'Nalalapat sa buong kaganapan. Upang i-override bawat wika, idagdag ang key na "votingPortalDateTimeFormat" sa tab na Localization gamit ang mga token na yyyy, MM, dd, HH, mm, ss (hal. dd/MM/yyyy HH:mm). Tingnan ang dokumentasyon para sa mga detalye.',
                    options: {
                        "legacy-gb-24h": "Legacy GB 24h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO Lokal (yyyy-MM-dd HH:mm)",
                        "us-12h": "US 12h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (katamtamang petsa, maikling oras)",
                        "date-only": "Date Only (walang oras)",
                        "custom": "Pasadyang format",
                    },
                    customFormat: {
                        label: "Pasadyang format ng petsa at oras",
                        helperText: "Gamitin ang mga token na yyyy, MM, dd, HH, mm, ss (hal. dd/MM/yyyy HH:mm). Ang iba pang karakter ay ipapakita nang literal.",
                        invalid: "Di-wastong format. Gumamit ng hindi bababa sa isa sa mga token na yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Walang Countdown",
                    COUNTDOWN: "Countdown",
                    COUNTDOWN_WITH_ALERT: "Countdown na may alerto",
                    sectionTitle: "Portal ng Pagboto",
                    policyLabel: "Patakaran sa Countdown ng Portal ng Pagboto",
                    coundownSecondsLabel: "Segundo bago mag-expire para ipakita ang countdown",
                    alertSecondsLabel: "Segundo bago mag-expire para ipakita ang Logout alert",
                },
                voterSigningPolicy: {
                    "policyLabel": "Patakaran sa Pagpirma ng Botante",
                    "no-signature": "Walang pirma",
                    "with-signature": "May pirma",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Patakaran sa digital na sertipiko ng botante",
                    enabled: "Naka-enable",
                    disabled: "Naka-disable",
                },
                enrollment: {
                    policyLabel: "Pagpaparehistro",
                    options: {
                        enabled: "Naka-enable",
                        disabled: "Naka-disable",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Naka-enable",
                        disabled: "Naka-disable",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Patakaran sa mga Seremonya ng Susi/Pagbilang",
                    options: {
                        "automated-ceremonies": "Payagan ang mga Awtomatikong Seremonya",
                        "manual-ceremonies": "Mga Manu-manong Seremonya",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Awtomatikong pagbilang muli matapos aprubahan ang import",
                    options: {
                        enabled: "Pinagana",
                        disabled: "Hindi pinagana",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Patakaran sa Timbang na Pagboto",
                    options: {
                        "areas-weighted-voting": "Timbang na Pagboto ayon sa mga Lugar",
                        "voters-weighted-voting": "Timbang na Pagboto ayon sa mga Botante",
                        "disabled-weighted-voting": "Hindi Pinagana ang Timbang na Pagboto",
                    },
                    noDelegated: "Ang Timbang na Pagboto ayon sa mga Botante ay hindi maaaring pagsamahin sa Delegadong Pagboto",
                    noDecodedBallots: "Ang Timbang na Pagboto ayon sa mga Botante ay hindi maaaring pagsamahin sa pagsasama ng mga na-decode na balota sa mga resulta",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Patakaran sa Delegadong Pagboto",
                    options: {
                        enabled: "Pinagana",
                        disabled: "Hindi pinagana",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Patakaran sa Pag-detect ng Wika",
                    options: {
                        "browser-detect": "Awtomatikong tuklasin mula sa browser",
                        "force-default": "Ipatupad ang default",
                    },
                },
                numberFormatPolicy: {
                    policyLabel: "Patakaran sa Format ng Numero",
                    helperText: "Nalalapat sa mga numerong ipinapakita sa mga resulta, dashboard at ulat.",
                    unknownPolicy: "Hindi kilalang format na '{{policy}}', ipinapakita bilang {{sample}}",
                },
            },
            error: {
                endDate: "Ang pagtatapos na petsa ay dapat pagkalipas ng petsa ng pagsisimula",
                startDate: "Ang petsa ng pagsisimula ay dapat nasa hinaharap",
                noResult: "Walang pang Kaganapan ng Halalan",
                endDateInvalid: "Ang petsa ng pagtatapos ay dapat nasa hinaharap",
            },
            voters: {
                title: "Mga Botante",
            },
            createElectionEventSuccess: "Nalikha ang Kaganapan ng Halalan",
            createElectionEventError: "Error sa paglikha ng kaganapan ng halalan",
            ivr: {
                tabs: {
                    config: "Configuration",
                    blacklist: "Listahan ng pag-block",
                    prompts: "Mga voice prompt",
                    emulator: "Emulator",
                },
                common: {
                    saveSuccess: "Matagumpay na na-save",
                    saveError: "Nabigong i-save",
                    deleteSuccess: "Matagumpay na natanggal",
                    deleteError: "Nabigong tanggalin",
                },
                config: {
                    configuredPhone: "Na-configure na numero ng telepono",
                    infoMsg: "I-configure ang IVR flow at ang mga property nito sa ibaba. Para sa higit pang detalye, makipag-ugnayan sa Sequent.",
                },
                prompts: {
                    emptyMsg: "Wala pang nagagawang prompt",
                    infoMsg: "I-configure ang mga prompt na ginagamit ng IVR. Kinakailangan ang mga announcement prompt, at maaaring i-override ang mga system prompt para sa mga gustong wika. Sinusuportahan ang SSML, kabilang ang paghahalo ng mga wika.",
                    editorTitle: "Prompt",
                    editorSubtitle: "Configuration ng prompt",
                },
                blacklist: {
                    columns: {
                        phone: "Numero ng telepono",
                        reason: "Dahilan",
                        createdAt: "Ginawa noong",
                        createdBy: "Ginawa ni",
                        createdBefore: "Ginawa bago ang",
                        createdAfter: "Ginawa pagkatapos ng",
                    },
                    emptyMsg: "Walang entry sa listahan ng pag-block",
                    infoMsg: "I-configure ang blocklist para sa IVR. Ang mga tawag mula sa mga numerong ito ay awtomatikong idi-disconnect ng system.",
                    noFilterMatch: "Walang entry na tumutugma sa ibinigay na mga filter",
                    phoneRequired: "Kinakailangan ang numero ng telepono",
                },
                emulator: {
                    infoMsg: "Pumili ng lugar at ng mga nais na halalan upang subukan ang IVR session.",
                    apiStatus: {
                        unavailable: "Hindi available ang emulator system sa iyong environment",
                        loading: "Nilo-load ang emulator system",
                        error: "Nagkaroon ng error sa pag-load ng emulator system",
                    },
                    hints: {
                        title: "Mga pahiwatig",
                        publishRequired: "Ang anumang pagbabagong ginawa sa mga halalan, mga paligsahan, o mga kandidato ay dapat munang i-publish para maging available. Tanging ang pinakabagong na-publish na mga ballot style para sa tumutugmang lugar ang gagamitin sa emulator.",
                        eventChangesImmediate: "Ang mga pagbabagong ginawa sa kaganapan ng halalan, gaya ng IVR configuration o mga pagbabago sa prompt, ay available kaagad kapag ni-restart ang emulator session.",
                        credentials: 'Ang valid na voter ID at PIN ay "123" at "123".',
                    },
                    sendDtmf: "Magpadala ng DTMF input",
                    sendTimeout: "Magpadala ng timeout",
                    disconnected: "Nadiskonekta",
                    startSession: "Magsimula ng bagong session",
                    endSession: "Tapusin ang session",
                    noStylesFound: "Walang nakitang na-publish na mga ballot style na tumutugma sa iyong mga pinili",
                    inputPlaceholder: "Ilagay ang iyong input (max na digit={{maxDigits}}, mga valid na input={{validInputs}}, timeout={{timeout}} s)",
                    blacklistCaller: "I-block ang tumatawag",
                    elections: "Mga halalan",
                    area: "Lugar",
                },
            },
            stats: {
                elegibleVoters: "Mga Kwalipikadong Botante",
                voters: "Mga Aktwal na Botante",
                elections: "Mga Halalan",
                contests: "Mga Paligsahan",
                areas: "Mga Lugar",
                sentEmails: "Mga Email na Naipadala",
                sentSMS: "Mga SMS na Naipadala",
                calendar: {
                    title: "Kalendaryo",
                    scheduled: "Naka-iskedyul",
                },
            },
            keys: {
                createNew: "Lumikha ng Seremonya ng mga Susi",
                emptyHeader: "Walang pang Seremonya ng mga Susi.",
                statusLabel: "Katayuan",
                waitingKeys: "Naghihintay sa Paglikha ng mga Susi..",
                started: "Nagsimula noong",
                actions: {
                    participate: "Lumahok sa seremonya ng mga susi",
                    view: "Tingnan ang seremonya ng mga susi",
                },
                breadCrumbs: {
                    configure: "I-configure",
                    ceremony: "Seremonya",
                    created: "Natapos",
                    start: "Simulan",
                    status: "Katayuan",
                    download: "I-download",
                    check: "Suriin",
                    success: "Natapos",
                },
                notify: {
                    participateNow: "Naanyayahan kang makibahagi sa seremonya ng mga susi. Mangyaring <1>i-click ang Aksyon ng Key ng seremonya</1> upang makilahok.",
                },
            },
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Pagsubaybay",
                data: "Data",
                ivr: "IVR",
                localization: "Localization",
                voters: "Mga Botante",
                areas: "Mga Lugar",
                keys: "Mga Susi",
                tally: "Pagbibilang",
                tallySheetImports: "Mga import ng tally sheet",
                publish: "I-publish",
                logs: "Mga Log",
                tasks: "Mga Gawain",
                events: "Naka-schedule na Kaganapan",
                notifications: "Mga Abiso",
                reports: "Ulat",
                approvals: "Mga pag-apruba",
                cas: "Mga Sertipiko",
            },
            tally: {
                emptyHeader: "Walang pang Tally.",
                title: "Tally ng Kaganapan ng Halalan",
                elections: "Mga Halalan",
                electionNumber: "Bilang ng mga Halalan",
                trustees: "Mga Tagapangasiwa",
                status: "Katayuan",
                permissionLabels: "Mga Label ng Pahintulot",
                tallyType: {
                    label: "Uri ng Bilang",
                    ELECTORAL_RESULTS: "Mga Resulta ng Halalan",
                    INITIALIZATION_REPORT: "Mga Resulta ng Inisyal",
                },
                create: {
                    title: "Lumikha ng Tally",
                    subtitle: "Lumikha ng bagong Tally para sa Kaganapan ng Halalan na ito",
                    createTallyButton: "Simulan ang Seremonya ng Tally",
                    createInitializationReportButton: "Lumikha ng Initialization Report",
                    error: {
                        create: "Error sa paglikha ng Tally",
                    },
                    success: "Nalikha ang Tally",
                },
                logs: {
                    noLogs: "Walang magagamit na mga log",
                },
                notify: {
                    noKeysTally: "Hindi maaaring magsimula ang Seremonya ng Tally hanggang ang Seremonya ng Key ay matagumpay na nakumpleto.",
                    noPublication: "Ang Seremonya ng Pagbibilang ay hindi maaaring magsimula hangga't hindi ka lumilikha ng isang post sa tab na I-publish.",
                    participateNow: "Naanyayahan kang makibahagi sa seremonya ng Tally. Mangyaring <1>i-click ang Aksyon ng Key ng seremonya</1> upang makilahok.",
                    startDisabled: "Hindi mo maaaring ipagpatuloy ang seremonya dahil walang napiling halalan o ang halalan ay hindi pa na-publish.",
                    ceremonyDisabled: "Hindi mo maaaring ipagpatuloy ang seremonya dahil ang tally session ay hindi konektado o ang pagsisimula ng seremonya ay hindi pinapayagan.",
                },
            },
            importAreas: {
                title: "Mag-import ng mga Lugar",
                subtitle: "Mag-import ng data ng mga lugar",
                areaParagraph: "Mag-import ng mga lugar gamit ang isang spreadsheet file sa format na Comma Separated Values (CSV).",
                importSuccess: "Matagumpay na na-import ang mga Lugar",
                importError: "Error sa pag-import ng mga Lugar",
                upsert: "Upsert ng mga Lugar",
            },
            import: {
                eetitle: "Mag-import ng Kaganapan ng Halalan",
                eesubtitle: "Mag-import ng data ng kaganapan ng halalan",
                title: "Mag-import ng mga Botante",
                subtitle: "Mag-import ng data ng mga botante",
                voters: "Mga Botante",
                votersParagraph: "Mag-import ng mga botante gamit ang isang spreadsheet file sa format na Comma Separated Values (CSV). I-download ang isang halimbawa ng import CSV file dito.",
                electionEventParagraph: "Mag-import ng mga Kaganapan ng Halalan gamit ang isang JSON file.",
                elections: "Mga Halalan",
                areas: "Mga Lugar",
                sha: "Pag-check ng Integridad (SHA-256)",
                cancel: "Kanselahin",
                import: "Mag-import",
                fileUploadSuccess: "Na-upload ang file sa server - ngunit hindi pa na-import",
                fileUploadError: "Error sa pag-upload ng file",
                importVotersSuccess: "Matagumpay na na-iskedyul ang Pag-import ng mga Botante",
                importVotersError: "Error sa pag-import ng mga Botante",
                importElectionEventSuccess: "Matagumpay na na-import ang kaganapan ng halalan",
                importElectionEventError: "Error sa pag-import ng kaganapan ng halalan",
                shaDialog: {
                    ok: "Oo, Mag-import nang walang Pag-check ng Integridad",
                    cancel: "Bumalik",
                    title: "Mag-import nang Walang Pag-check ng Integridad?",
                    description: "Hindi mo ipinakita ang field para sa Pag-check ng Integridad (SHA-256). Mangyaring kumpirmahin na ini-import mo ang tamang file at nais mo itong i-import.",
                },
                passwordDialog: {
                    title: "Password sa pag-decrypt",
                    description: "Ilagay ang password para i-decrypt ang file",
                    label: "Password",
                    copyPassword: "Kopyahin ang Password",
                    ok: "Ok",
                },
            },
            export: {
                title: "I-export ang Kaganapang Halalan",
                subtitle: "Ang pag-export ay maaaring isang mahabang proseso. Sigurado ka bang gusto mong i-export ang mga tala?",
                encryptWithPassword: "I-encrypt gamit ang Password",
                passwordForcedNote: "Mapoprotektahan pa rin ng password ang archive: palaging naka-encrypt ang mga ulat, aplikasyon at datos ng bulletin board. Lagyan ng tsek ang kahon para isama rin ang mga na-decrypt na lihim na field ng botante.",
                includeVoters: "Isama ang mga Botante",
                activityLogs: "Mga Log ng Aktibidad",
                bulletinBoard: "Bulletin Board",
                publications: "Mga Publikasyon",
                s3Files: "Mga File ng S3",
                scheduledEvents: "Nakatakdang Mga Kaganapan",
                exportSuccess: "Matagumpay na nai-export ang Kaganapang Halalan",
                exportError: "Error sa pag-export ng Kaganapang Halalan",
                passwordTitle: "Password",
                passwordDescription: "Password para i-decrypt ang file:",
                copiedSuccess: "Nakopya ang password sa clipboard",
                copiedError: "Error sa pag-copy ng password sa clipboard",
                reports: "Mga Ulat",
                applications: "Mga Aplikasyon",
                tally: "Bilang",
                certificates: "Mga Sertipiko",
            },
            taskNotification: "{{action}} ay nagsimula na. Maaari mong makita ang status nito sa Talahanayan ng Pagpapatupad ng Mga Gawain.",
        },
        electionScreen: {
            common: {
                title: "Halalan",
                subtitle: "Pag-configure ng halalan.",
                fileLoaded: "Na-load ang file",
                noPermission: "Wala kang pahintulot na ma-access ang halalang ito.",
            },
            edit: {
                general: "Pangkalahatan",
                dates: "Petsa",
                votingPeriod: "Panahon ng Pagboto",
                language: "Wika",
                allowed: "Pinapayagang Mga Channel ng Pagboto",
                default: "Default",
                defaultLang: "Default na wika",
                receipts: "Mga Resibo",
                image: "Larawan",
                advanced: "Advanced na Pag-configure",
                numAllowedVotes: "Bilang ng pinapayagang boto",
                reorder: "I-reorder ang mga paligsahan",
                castVoteConfirm: "Modal ng Pagkumpirma ng Pagboto",
                gracePeriodPolicy: "Patakaran sa Palugit",
                allowTallyPolicy: "Payagan si Tally",
                permissionLabel: "Label ng pahintulot",
                custom_filters: "Pasadyang mga filter",
            },
            field: {
                name: "Pangalan",
                language: "Wika",
                votingChannels: "Mga Channel ng Pagboto",
                startDateTime: "Petsa at Oras ng Pagsisimula",
                endDateTime: "Petsa at Oras ng Pagtatapos",
                startDateTimeWithTimezone: "Petsa at Oras ng Pagsisimula ({{timezone}})",
                endDateTimeWithTimezone: "Petsa at Oras ng Pagtatapos ({{timezone}})",
                scheduledOpening: "Naka-iskedyul na Pagbubukas",
                scheduledClosing: "Naka-iskedyul na Pagsasara",
                alias: "Alias",
                description: "Paglalarawan",
                securityConfirmationHtml: "HTML ng Kumpirmasyon sa Seguridad",
                ivrPrompt: "Prompt ng IVR",
                externalId: "Panlabas na ID",
            },
            securityConfirmationPolicy: {
                label: "Patakaran sa Checkbox ng Kumpirmasyon sa Seguridad",
                none: "Wala",
                mandatory: "Kinakailangan",
            },
            error: {
                fileError: "Error sa pag-upload ng file",
                fileLoaded: "Na-load ang file",
                endDate: "Ang petsa ng pagtatapos ay dapat pagkalipas ng petsa ng pagsisimula",
                startDate: "Ang petsa ng pagsisimula ay dapat nasa hinaharap",
                endDateInvalid: "Ang petsa ng pagtatapos ay dapat nasa hinaharap",
            },
            createElectionEventSuccess: "Nalikha ang Kaganapan ng Halalan",
            createElectionEventError: "Error sa paglikha ng kaganapan ng halalan",
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Pagsubaybay",
                data: "Data",
                voters: "Mga Botante",
                publish: "I-publish",
                logs: "Mga Log",
                approvals: "Mga pag-apruba",
                tallySheets: "Mga Talaksahan",
            },
            gracePeriodPolicy: {
                "label": "Patakaran sa Palugit",
                "no-grace-period": "Walang palugit",
                "grace-period-without-alert": "Palugit na walang babala",
                "gracePeriodSecs": "Palugit sa segundo",
            },
            allowTallyPolicy: {
                "allowed": "Tinogotan",
                "disallowed": "Hindi Pinapayagan",
                "requires-voting-period-end": "Nangangailangan ng Pagtatapos ng Panahon ng Pagboto",
            },
            initializeReportPolicy: {
                "label": "I-initialize ang Patakaran sa Ulat",
                "not-required": "Hindi Kinakailangan",
                "required": "Kinakailangan",
            },
            castVoteGoldLevelPolicy: {
                label: "Patakaran sa gold level na authentication",
                options: {
                    "gold-level": "Gold level na authentication",
                    "no-gold-level": "Walang gold level na authentication",
                },
            },
            slates: {
                enable: {
                    label: "I-enable ang mga slate",
                    helper: "Kapag naka-enable, makakapili ang mga botante ng slate na may pangalan at mababago ang anumang paligsahan, kasama ang mga independiyenteng kandidato.",
                },
                disable: {
                    confirm: "I-disable ang mga slate",
                    message_one: "May {{count}} slate ang halalang ito. Kapag in-disable ang mga slate, buburahin ito pag-save.",
                    message_many: "May {{count}} na slate ang halalang ito. Kapag in-disable ang mga slate, buburahin ang mga ito pag-save.",
                    message_other: "May {{count}} na slate ang halalang ito. Kapag in-disable ang mga slate, buburahin ang mga ito pag-save.",
                },
                mobileCandidateLists: {
                    label: "Mga listahan ng kandidato sa mobile",
                    helper: "Kung paano unang lumalabas sa telepono ang listahan ng kandidato ng bawat slate: Nakatiklop o Nakabukas. Maaari pa ring buksan o isara ng mga botante ang anumang listahan. Sa desktop, laging ipinapakita ang lahat ng kandidato.",
                    options: {
                        collapsed: "Nakatiklop",
                        expanded: "Nakabukas",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Patakaran sa Pamagat ng Pangunahing Screen",
                options: {
                    "election": "Pamagat ng halalan",
                    "election-event": "Pamagat ng kaganapan ng halalan",
                },
            },
            consolidatedReportPolicy: {
                label: "Patakaran sa Pinagsamang Ulat",
                options: {
                    "generate": "Bumuo",
                    "do-not-generate": "Huwag bumuo",
                },
            },
            declineToVotePolicy: {
                label: "Patakaran sa pagtangging bumoto",
                options: {
                    enabled: "Pinagana",
                    disabled: "Naka-disable",
                },
            },
            blankBallotsPolicy: {
                label: "Patakaran sa mga blangkong balota",
                options: {
                    enabled: "Pinagana",
                    disabled: "Naka-disable",
                },
            },
            votingScreenBackPolicy: {
                label: "Patakaran sa pindutang Bumalik ng screen ng pagboto",
                options: {
                    "election-selection-screen": "Pumunta sa screen ng pagpili ng halalan",
                    "start-screen": "Pumunta sa panimulang screen ng halalan",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Mga Nangungupahan",
            },
            new: {
                subtitle: "Lumikha ng bagong nangungupahan",
            },
            createSuccess: "Nangungupahan na nilikha",
            createError: "Error sa paglikha ng nangungupahan",
        },
        usersAndRolesScreen: {
            noPermissions: "Wala kang pahintulot na ma-access ang mga tagagamit o tungkulin.",
            common: {
                title: "Mga Tagagamit at Tungkulin",
                subtitle: "Pangkalahatang pag-configure",
                mobileNumber: "Mobile",
            },
            editPassword: {
                passwordPolicyViolation: "Hindi sumusunod ang password sa Patakaran sa Password para sa kaganapang ito ng halalan. Suriin ang patakaran sa Data ng Kaganapan ng Halalan at maglagay ng wastong password.",
                passwordPolicyRules: {
                    minimumLength: "Ang pinakamababang haba ng password ay {{count}}.",
                    maximumLength: "Ang pinakamataas na haba ng password ay {{count}}.",
                    uppercase: "Kinakailangang malalaking titik: {{count}}.",
                    lowercase: "Kinakailangang maliliit na titik: {{count}}.",
                    digits: "Kinakailangang mga numero: {{count}}.",
                    specialCharacters: "Kinakailangang espesyal na mga karakter: {{count}}.",
                },
                label: "Palitan ang password",
                temporatyLabel: "Pansamantala",
                temporatyInfo: "Kung naka-enable, kinakailangang palitan ng tagagamit ang password sa susunod na pag-login",
            },
            users: {
                title: "Mga Tagagamit",
                subtitle: "Tingnan at i-edit ang data ng tagagamit",
                review: {
                    title: "Suriin ang mga Pagbabago",
                    subtitle: "Kumpirmahin ang mga update na ito bago isumite.",
                    confirm: "Kumpirmahin ang mga Pagbabago",
                    noChanges: "Walang pagbabagong susuriin",
                    field: "Field",
                    currentValue: "Kasalukuyang Halaga",
                    newValue: "Bagong Halaga",
                },
                edit: {
                    title: "Data ng Tagagamit",
                    subtitle: "Tingnan at i-edit ang tagagamit",
                },
                create: {
                    title: "Tagagamit",
                    subtitle: "Lumikha ng tagagamit",
                },
                fields: {
                    "has_voted": "Nakaboto",
                    "support_materials_viewed": "Mga Karagdagang Materyales na Nakita",
                    "vote-weight": "Bigat ng Boto",
                    "voted-channel": "Channel ng pagboto",
                    "disable-comment": "Komento sa pag-disable",
                    "username": "Username",
                    "first_name": "Unang Pangalan",
                    "last_name": "Huling Pangalan",
                    "email": "Email",
                    "enabled": "Pinagana",
                    "emailVerified": "Na-verify ang Email",
                    "groups": "Mga Grupo",
                    "attributes": "Mga Katangian",
                    "area": "Lugar",
                    "password": "Password",
                    "savePassword": "I-save ang password",
                    "repeatPassword": "Ulitin ang Password",
                    "passwordMismatch": "Dapat magkatugma ang mga password",
                    "passwordLengthValidate": "Ang password ay dapat hindi bababa sa 8 karakter",
                    "passwordUppercaseValidate": "Ang password ay dapat maglaman ng hindi bababa sa isang malaking titik",
                    "passwordLowercaseValidate": "Ang password ay dapat maglaman ng hindi bababa sa isang maliit na titik",
                    "passwordDigitValidate": "Ang password ay dapat maglaman ng hindi bababa sa isang digit",
                    "passwordSpecialCharValidate": "Ang password ay dapat maglaman ng hindi bababa sa isang espesyal na karakter",
                    "trustee": "Kumilos bilang trustee",
                    "permissionLabel": "Label ng pahintulot",
                    "authorized-election-ids": "Halalan",
                },
                delete: {
                    body: "Sigurado ka bang gusto mong tanggalin ang tagagamit na ito?",
                    bulkBody: "Sigurado ka bang gusto mong tanggalin ang mga napiling tagagamit?",
                    bulkBodySelected: "Tanggalin ang {{count}} napiling tagagamit? Hindi na ito maaaring bawiin.",
                    bulkBodyChoose: "{{count}} tagagamit ang napili. Maaari mo ring tanggalin ang lahat ng tagagamit na tumutugma sa kasalukuyang mga filter, na maaaring mas marami. Hindi na ito maaaring bawiin.",
                    okSelected: "Tanggalin ang {{count}} napili",
                    okAllMatching: "Tanggalin ang lahat ng tumutugma",
                },
                notifications: {
                    exportError: "Error sa pag-export ng mga tagagamit",
                    deleteError: "Error sa pagtanggal ng tagagamit",
                    deleteSuccess: "Natanggal ang tagagamit",
                    multipleDeleteSuccess: "Natanggal ang mga tagagamit",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Liham ng impormasyon para sa botante",
                    generate: "Bumuo",
                    confirmation: "Bumuo ng Liham ng impormasyon para sa botanteng ito? Magtatalaga ng bagong password at isasama ito sa isang naka-encrypt na PDF.",
                    generationStarted: "Nagsimula na ang pagbuo ng Liham ng impormasyon",
                    generationError: "Hindi mabuo ang Liham ng impormasyon",
                    policyNotConfigured: "Hindi naka-configure ang Patakaran sa Password. I-configure ito sa Data ng Kaganapan ng Halalan bago bumuo ng liham.",
                    policyMinimumLengthMissing: "Dapat may pinakamababang haba ang Patakaran sa Password bago bumuo ng liham.",
                    policyCharacterClassMissing: "Dapat may hindi bababa sa isang klase ng karakter ang Patakaran sa Password bago bumuo ng liham.",
                },
                title: "Mga Botante",
                subtitle: "Tingnan at i-edit ang data ng botante",
                secretAttribute: {
                    storedPlaceholder: "Nakaimbak na naka-encrypt na halaga",
                    reveal: "Ipakita",
                    hide: "Itago",
                    revealError: "Hindi maipakita ang naka-encrypt na field ng botante",
                    includeInExport: "Isama ang na-decrypt na mga lihim na field ng botante",
                    exportWarning: "Sensitibong export: ang na-download na CSV ay maglalaman ng mga field na ito bilang plain text.",
                    clear: "Burahin",
                    add: "Magdagdag ng halaga",
                    remove: "Alisin ang halaga",
                },
                review: {
                    title: "Suriin ang mga Pagbabago",
                    subtitle: "Kumpirmahin ang mga update na ito bago isumite.",
                    confirm: "Kumpirmahin ang mga Pagbabago",
                    noChanges: "Walang pagbabagong susuriin",
                    field: "Field",
                    currentValue: "Kasalukuyang Halaga",
                    newValue: "Bagong Halaga",
                },
                logs: {
                    label: "Mga Log ng Gumagamit",
                },
                create: {
                    title: "Botante",
                    subtitle: "Lumikha ng Botante",
                },
                manualVerification: {
                    label: "Manwal na I-verify",
                    verify: "Manu-manong i-verify ang botante",
                    body: "Manu-manong i-verify ang botante. Makakakuha ka ng PDF na may QR Code link na nagpapahintulot sa botante na mag-login na hindi dumaan sa online KYC.",
                    noEmailOrPhone: "Ang botanteng ito ay hindi maaaring mano-manong ma-verify dahil wala silang nakatalagang email address o numero ng telepono.",
                },
                emptyHeader: "Wala pang mga botante.",
                askCreate: "Gusto mo bang lumikha ng isa?",
                errors: {
                    editError: "Error sa pag-edit ng botante",
                    editErrorReason: "Error sa pag-edit ng botante: {{reason}}",
                    editSuccess: "Nai-edit ang botante",
                    createError: "Error sa paglikha ng botante",
                    createErrorReason: "Error sa paglikha ng botante: {{reason}}",
                    createSuccess: "Nalikha ang botante",
                    attribute: {
                        invalidNamed: 'Tinanggihan ang "{{field}}": {{constraint}}',
                        fieldsToCorrect: "May mga field na kailangang itama bago mag-save",
                        hintBetween: "Sa pagitan ng {{min}} at {{max}} na karakter",
                        hintMin: "Hindi bababa sa {{min}} na karakter",
                        hintMax: "Hindi hihigit sa {{max}} na karakter",
                        andMore: "at {{count}} pa",
                        invalidLength: 'Ang "{{field}}" ay dapat na nasa pagitan ng {{min}} at {{max}} na karakter',
                        tooShort: 'Ang "{{field}}" ay dapat na hindi bababa sa {{min}} na karakter',
                        tooLong: 'Ang "{{field}}" ay dapat na hindi hihigit sa {{max}} na karakter',
                        required: 'Ang "{{field}}" ay kinakailangan',
                        invalidEmail: 'Ang "{{field}}" ay dapat na wastong email address',
                        invalidFormat: 'Ang "{{field}}" ay walang inaasahang format',
                        invalid: 'Ang "{{field}}" ay may hindi wastong halaga',
                    },
                    createPasswordError: "Nalikha ang botante, ngunit hindi maitakda ang password nito",
                    createPasswordErrorReason: "Nalikha ang botante, ngunit hindi maitakda ang password nito: {{reason}}",
                },
                delete: {
                    body: "Sigurado ka bang gusto mong tanggalin ang botante na ito?",
                    bulkBody: "Sigurado ka bang gusto mong tanggalin ang mga napiling botante?",
                    bulkBodySelected: "Tanggalin ang {{count}} napiling botante? Hindi na ito maaaring bawiin.",
                    bulkBodyChoose: "{{count}} botante ang napili. Maaari mo ring tanggalin ang lahat ng botante na tumutugma sa kasalukuyang mga filter, na maaaring mas marami. Hindi na ito maaaring bawiin.",
                    okSelected: "Tanggalin ang {{count}} napili",
                    okAllMatching: "Tanggalin ang lahat ng tumutugma",
                },
                notifications: {
                    exportError: "Error sa pag-export ng mga botante",
                    deleteError: "Error sa pagtanggal ng botante",
                    deleteSuccess: "Natanggal na ang botante",
                    multipleDeleteSuccess: "Natanggal na ang mga botante",
                    manualVerificationError: "Error sa manu-manong pag-verify ng botante",
                    manualVerificationSuccess: "Matagumpay na na-verify nang manu-mano ang botante, nagda-download ng PDF..",
                },
            },
            roles: {
                title: "Mga Tungkulin",
                edit: {
                    title: "Data ng Tungkulin",
                    subtitle: "Tingnan at i-edit ang tungkulin",
                },
                create: {
                    title: "Tungkulin",
                    subtitle: "Lumikha ng tungkulin",
                },
                errors: {
                    createError: "Error sa paglikha ng tungkulin",
                    createSuccess: "Nalikha ang tungkulin",
                },
                fields: {
                    name: "Pangalan",
                },
                delete: {
                    body: "Sigurado ka bang gusto mong tanggalin ang tungkulin na ito?",
                },
                notifications: {
                    deleteError: "Error sa pagtanggal ng tungkulin",
                    deleteSuccess: "Naitanggal ang tungkulin",
                    permissionEditError: "Error sa pag-edit ng pahintulot",
                    permissionEditSuccess: "Na-edit ang pahintulot",
                },
            },
            permissions: {
                "voter-information-letter": "Bumuo ng Liham ng impormasyon para sa botante",
                "admin-user": "Admin na Tagagamit",
                "admin-dashboard-view": "Tingnan ang Dashboard ng Admin",
                "application-export": "Pag-export ng Aplikasyon",
                "application-import": "Pag-import ng Aplikasyon",
                "tenant-create": "Lumikha ng Tenant",
                "tenant-read": "Basahin ang Tenant",
                "tenant-write": "I-edit ang Tenant",
                "tenant-delete": "Tanggalin ang Tenant",
                "election-event-create": "Lumikha ng Kaganapan ng Halalan",
                "election-event-read": "Basahin ang Kaganapan ng Halalan",
                "election-event-write": "I-edit ang Kaganapan ng Halalan",
                "keycloak-realm-attributes-read": "Basahin ang mga katangian ng realm ng Keycloak",
                "keycloak-realm-attributes-write": "I-edit ang mga katangian ng realm ng Keycloak",
                "election-event-delete": "Tanggalin ang Kaganapan ng Halalan",
                "voter-create": "Lumikha ng Botante",
                "voter-read": "Basahin ang Botante",
                "voter-write": "I-edit ang Botante",
                "voter-secret-attribute-read": "Ipakita ang mga Lihim na Field ng Botante",
                "voter-secret-attribute-write": "I-edit ang mga Lihim na Field ng Botante",
                "user-create": "Lumikha ng Tagagamit",
                "user-read": "Basahin ang Tagagamit",
                "user-write": "I-edit ang Tagagamit",
                "user-permission-create": "Lumikha ng Pahintulot ng Tagagamit",
                "user-permission-read": "Basahin ang Pahintulot ng Tagagamit",
                "user-permission-write": "I-edit ang Pahintulot ng Tagagamit",
                "role-create": "Lumikha ng Tungkulin",
                "role-read": "Basahin ang Tungkulin",
                "role-write": "I-edit ang Tungkulin",
                "role-assign": "I-assign ang Tungkulin",
                "communication-template-create": "Lumikha ng Template ng Komunikasyon",
                "communication-template-read": "Basahin ang Template ng Komunikasyon",
                "communication-template-write": "I-edit ang Template ng Komunikasyon",
                "notification-read": "Basahin ang Notipikasyon",
                "notification-write": "I-edit ang Notipikasyon",
                "notification-send": "Magpadala ng Notipikasyon",
                "area-read": "Basahin ang Area",
                "area-write": "I-edit ang Area",
                "election-state-write": "I-edit ang Estado ng Halalan",
                "election-type-create": "Lumikha ng Uri ng Halalan",
                "election-type-read": "Basahin ang Uri ng Halalan",
                "election-type-write": "I-edit ang Uri ng Halalan",
                "voting-channel-read": "Basahin ang Channel ng Pagboto",
                "voting-channel-write": "I-edit ang Channel ng Pagboto",
                "trustee-create": "Lumikha ng Tagapangasiwa",
                "trustee-read": "Basahin ang Tagapangasiwa",
                "trustee-write": "I-edit ang Tagapangasiwa",
                "tally-read": "Basahin ang Tally",
                "tally-start": "Simulan ang Tally",
                "tally-write": "I-edit ang Tally",
                "tally-results-read": "Basahin ang Mga Resulta ng Tally",
                "publish-read": "Basahin ang Publish",
                "publish-write": "I-edit ang Publish",
                "publish-results-read": "Basahin ang Results Publication",
                "publish-results-write": "I-edit ang Results Publication",
                "logs-read": "Basahin ang Logs",
                "tasks-read": "Basahin ang Pagpapatupad ng Mga Gawain",
                "keys-read": "Basahin ang Mga Susi",
                "document-upload": "Mag-upload ng Mga Dokumento",
                "document-download": "I-download ang Mga Dokumento",
                "document-password-read": "Basahin ang Mga Password ng Dokumento",
                "tally-sheet-create": "Lumikha ng Tally Sheet",
                "tally-sheet-import-create": "Lumikha ng Import ng Tally Sheet",
                "tally-sheet-import-review": "Suriin ang Import ng Tally Sheet",
                "tally-sheet-import-view": "Tingnan ang Import ng Tally Sheet",
                "tally-recount-execute": "Isagawa ang Recount ng Tally",
                "trustee-ceremony": "Seremonya ng Tagapangasiwa",
                "tally-sheet-review": "Suriin ang Tally Sheet",
                "tally-sheet-view": "Tingnan ang Tally Sheet",
                "admin-ceremony": "Seremonya ng Admin",
                "tally-sheet-delete": "Tanggalin ang Tally Sheet",
                "cast-vote-read": "Basahin ang Na-cast na Mga Boto",
                "document-read": "Basahin ang Mga Dokumento",
                "document-write": "I-edit ang Mga Dokumento",
                "support-material-read": "Basahin ang Suportang Materyal",
                "support-material-write": "I-edit ang Suportang Materyal",
                "miru-create": "Miru Lumikha",
                "miru-download": "Miru I-download",
                "miru-send": "Miru Ipadala",
                "miru-sign": "Miru Lagdaan",
                "contest-write": "I-edit ang paligsahan",
                "contest-read": "Basahin ang paligsahan",
                "candidate-write": "I-edit ang mga kandidato",
                "candidate-read": "Basahin ang mga kandidato",
                "permission-label-write": "I-edit ang label ng pahintulot",
                "scheduled-event-write": "I-edit ang Naka-schedule na Kaganapan",
                "contest-create": "Lumikha ng Paligsahan",
                "contest-delete": "Tanggalin ang Paligsahan",
                "candidate-create": "Lumikha ng Kandidato",
                "candidate-delete": "Tanggalin ang Kandidato",
                "election-create": "Lumikha ng Halalan",
                "election-read": "Basahin ang Halalan",
                "election-write": "I-edit ang Halalan",
                "election-delete": "Tanggalin ang Halalan",
                "election-event-archive": "I-archive ang Kaganapang Halalan",
                "election-data-tab": "Tingnan ang Datos ng Halalan",
                "election-event-areas-tab": "Tingnan ang mga Lugar ng Kaganapang Halalan",
                "election-event-data-tab": "Tingnan ang Datos ng Kaganapang Halalan",
                "election-event-keys-tab": "Tingnan ang mga Susi ng Kaganapang Halalan",
                "election-event-logs-tab": "Tingnan ang mga Log ng Kaganapang Halalan",
                "election-event-publish-tab": "Tingnan ang Pag-publish ng Kaganapang Halalan",
                "election-event-reports-tab": "Tingnan ang mga Ulat ng Kaganapang Halalan",
                "election-event-scheduled-tab": "Tingnan ang Iskedyul ng Kaganapang Halalan",
                "election-event-tally-tab": "Tingnan ang Tally ng Kaganapang Halalan",
                "election-event-tasks-tab": "Tingnan ang mga Gawain ng Kaganapang Halalan",
                "election-event-voters-tab": "Tingnan ang mga Botante ng Kaganapang Halalan",
                "election-publish-tab": "Tingnan ang Pag-publish ng Halalan",
                "election-voters-tab": "Tingnan ang mga Botante ng Halalan",
                "report-write": "I-edit ang Mga Ulat",
                "report-read": "Basahin ang Mga Ulat",
                "users-menu": "Tingnan ang mga user at mga role",
                "settings-menu": "Tingnan ang mga setting",
                "templates-menu": "Tingnan ang mga template",
                "settings-election-types-tab": "Tingnan ang mga setting ng mga uri ng halalan",
                "settings-voting-channels-tab": "Tingnan ang mga setting ng mga channel ng pagboto",
                "settings-templates-tab": "Tingnan ang mga setting ng mga template",
                "settings-languages-tab": "Tingnan ang mga setting ng mga wika",
                "settings-localization-tab": "Tingnan ang mga setting ng lokalisasyon",
                "settings-look-feel-tab": "Tingnan ang mga setting ng itsura",
                "settings-trustees-tab": "Tingnan ang mga setting ng mga tagapangasiwa",
                "settings-countries-tab": "Tingnan ang mga setting ng mga bansa",
                "voter-import": "I-import ang Botante",
                "ee-voters-columns": "Tingnan ang mga Kolum ng mga Botante ng Kaganapang Halalan",
                "voter-manually-verify": "Manwal na I-verify ang Botante",
                "ee-voters-logs": "Tingnan ang mga Log ng mga Botante ng Kaganapang Halalan",
                "voter-export": "I-export ang Botante",
                "ee-voters-filters": "Tingnan ang mga Filter ng mga Botante ng Kaganapang Halalan",
                "voter-delete": "Tanggalin ang Botante",
                "voter-change-password": "Palitan ang Password ng Botante",
                "election-event-localization-selector": "Tagapili ng Lokalisasyon ng Kaganapang Halalan",
                "localization-create": "Lumikha ng Lokalisasyon",
                "localization-read": "Basahin ang Lokalisasyon",
                "localization-write": "I-edit ang Lokalisasyon",
                "localization-delete": "Tanggalin ang Lokalisasyon",
                "area-create": "Lumikha ng Lugar",
                "area-delete": "Tanggalin ang Lugar",
                "area-export": "I-export ang Lugar",
                "area-import": "I-import ang Lugar",
                "area-upsert": "Magpasok o I-update ang Lugar",
                "election-event-areas-columns": "Mga Kolum ng mga Lugar ng Kaganapang Halalan",
                "election-event-areas-filters": "Mga Filter ng mga Lugar ng Kaganapang Halalan",
                "election-event-tasks-back-button": "Bumalik sa mga Gawain ng Kaganapang Halalan",
                "election-event-tasks-columns": "Mga Kolum ng mga Gawain ng Kaganapang Halalan",
                "election-event-tasks-filters": "Mga Filter ng mga Gawain ng Kaganapang Halalan",
                "task-export": "I-export ang mga Gawain",
                "application-read": "Basahin ang Aplikasyon",
                "application-write": "I-edit ang Aplikasyon",
                "logs-export": "I-export ang mga Log",
                "election-event-logs-columns": "Mga Kolum ng mga Log ng Kaganapang Halalan",
                "election-events-logs-filters": "Mga Filter ng mga Log ng Kaganapang Halalan",
                "election-event-scheduled-event-columns": "Mga Kolum ng mga Naka-iskedyul na Kaganapan ng Kaganapang Halalan",
                "scheduled-event-create": "Lumikha ng Naka-iskedyul na Kaganapan",
                "scheduled-event-delete": "Tanggalin ang Naka-iskedyul na Kaganapan",
                "election-event-reports-columns": "Mga Kolum ng mga Ulat ng Kaganapang Halalan",
                "report-create": "Lumikha ng Ulat",
                "report-delete": "Tanggalin ang Ulat",
                "report-generate": "Lumikha ng Ulat",
                "report-preview": "I-preview ang Ulat",
                "monitor-authenticated-voters": "Pagmamatyag sa Mga Awtentikadong Botante",
                "monitor-all-approve-disapprove-voters": "Basahin ang Pagmamatyag sa Mga Aprubado at Hindi Aprubado",
                "monitor-automatic-approve-disapprove-voters": "Basahin ang Pagmamatyag sa Awtomatikong Aprubado at Hindi Aprubado",
                "monitor-manually-approve-disapprove-voters": "Basahin ang Pagmamatyag sa Manu-manong Aprubado at Hindi Aprubado",
                "monitor-enrolled-overseas-voters": "Basahin ang Pagmamatyag sa Mga Naka-enroll na Botante sa Ibayong Dagat",
                "monitor-posts-already-closed-voting": "Basahin ang Pagmamatyag sa Mga Post na Sarado na ang Botohan",
                "monitor-posts-already-generated-election-results": "Basahin ang Pagmamatyag sa Mga Post na Naglabas na ng Resulta ng Halalan",
                "monitor-posts-already-opened-voting": "Basahin ang Pagmamatyag sa Mga Post na Binuksan na ang Botohan",
                "monitor-posts-already-started-counting-votes": "Basahin ang Pagmamatyag sa Mga Post na Sinimulan na ang Pagbilang ng Boto",
                "monitor-posts-initialized-the-system": "Basahin ang Pagmamatyag sa Mga Post na Inisyalisa ang Sistema",
                "monitor-posts-started-voting": "Basahin ang Pagmamatyag sa Mga Post na Nagsimula na ang Botohan",
                "monitor-posts-transmitted-results": "Basahin ang Pagmamatyag sa Mga Post na Nagpadala ng Resulta",
                "monitor-voters-voted-test-election": "Basahin ang Pagmamatyag sa Mga Botanteng Bumoto sa Test Election",
                "monitor-voters-who-voted": "Basahin ang Pagmamatyag sa Mga Botanteng Bumoto",
                "election-event-publish-preview": "I-preview ang Publikasyon ng Kaganapang Halalan",
                "election-event-publish-back-button": "Bumalik sa Publikasyon ng Kaganapang Halalan",
                "election-event-publish-columns": "Mga Kolum ng Publikasyon ng Kaganapang Halalan",
                "election-event-publish-filters": "Mga Filter ng Publikasyon ng Kaganapang Halalan",
                "publish-create": "Lumikha ng Publikasyon",
                "publish-regenerate": "Muling Lumikha ng Publikasyon",
                "publish-export": "I-export ang Publikasyon",
                "publish-start-voting": "Simulan ang Pagboto",
                "publish-pause-voting": "I-pause ang Pagboto",
                "publish-stop-voting": "Itigil ang Pagboto",
                "publish-changes": "I-publish ang mga Pagbabago",
                "election-event-publish-view": "Tingnan ang Publikasyon ng Kaganapang Halalan",
                "election-event-keys-columns": "Mga Kolum ng mga Susi ng Kaganapang Halalan",
                "create-ceremony": "Lumikha ng Seremonya",
                "export-ceremony": "I-export ang Seremonya",
                "election-event-tally-columns": "Mga Kolum ng Tally ng Kaganapang Halalan",
                "election-event-tally-back-button": "Bumalik sa Tally ng Kaganapang Halalan",
                "transmition-ceremony": "Seremonya ng Transmisyon",
                "admin-ip-address-view": "Tingnan ang IP Address",
                "election-approvals-tab": "Tingnan ang mga Pagmamatyag sa Halalan",
                "election-event-approvals-tab": "Tingnan ang mga Pagmamatyag ng Kaganapang Halalan",
                "election-ip-address-view": "Tingnan ang IP Address ng Halalan",
                "election-dashboard-tab": "Tingnan ang Dashboard ng Halalan",
                "trustees-export": "I-export ang mga Tagapangasiwa",
                "user-import": "Pag-import ng Mga Tagagamit",
                "voter-voted-edit": "I-edit ang mga botanteng bumoto",
                "voter-email-tlf-edit": "I-edit ang mga field ng email/telepono ng mga botante",
                "cloudflare-write": "I-edit ang mga patakaran sa pag-block ng bansa sa Cloudflare",
                "transmission-report-generate": "Lumikha ng Ulat ng Transmisyon",
                "google-meet-link": "Bumuo ng Google Meet Link",
                "service-account": "Account ng serbisyo",
                "datafix-account": "Account ng Datafix",
                "gold": "Ginto",
                "silver": "Pilak",
                "election-event-ivr-tab": "Tingnan ang IVR ng kaganapan ng halalan",
                "election-event-cas-tab": "Tingnan ang CAS ng kaganapan ng halalan",
                "ca-read": "Basahin ang mga certificate authority",
                "ca-write": "I-edit ang mga certificate authority",
                "generate-preview": "Bumuo ng preview",
                "preview-read": "Basahin ang preview",
                "tally-resolution-submit": "Isumite ang resolusyon ng tally",
                "phone-blacklist-read": "Basahin ang blacklist ng telepono",
                "phone-blacklist-create": "Gumawa ng mga entry sa blacklist ng telepono",
                "phone-blacklist-update": "I-edit ang mga entry sa blacklist ng telepono",
                "phone-blacklist-delete": "Tanggalin ang mga entry sa blacklist ng telepono",
                "election-event-voter-list-reconciliation": "I-reconcile ang listahan ng mga botante ng kaganapan ng halalan",
            },
        },
        generalSettingsScreen: {
            body: "I-enable ang mga wika sa sistema. Tanging ang mga wikang pinagana dito ang magagamait para sa mga kaganapan ng halalan.",
        },
        eventsScreen: {
            title: "Naka-schedule na Kaganapan",
            subtitle: "Pinamamahalaan ang configuration ng awtomatikong pagpapatupad ng mga kaganapan tulad ng pagsisimula o pagtatapos ng panahon ng pagboto.",
            messages: {
                createSuccess: "Matagumpay na nalikha ang Naka-schedule na Kaganapan",
                createError: "Error sa paglikha ng Naka-schedule na Kaganapan",
                editSuccess: "Matagumpay na na-edit ang Naka-schedule na Kaganapan",
                editError: "Error sa pag-edit ng Naka-schedule na Kaganapan",
                onlineWithEarlyVoting: "Hindi maaaring buksan ng iskedyul ng pagsisimula ang Online at Maagang pagboto nang sabay: ang maagang pagboto ay dapat magsimula bago ang online na pagboto.",
            },
            eventType: {
                label: "Uri",
                ALLOW_INIT_REPORT: "Payagan ang ulat ng inisyalisasyon",
                START_VOTING_PERIOD: "Simula ng Panahon ng Pagboto",
                END_VOTING_PERIOD: "Pagtatapos ng Panahon ng Pagboto",
                ALLOW_VOTING_PERIOD_END: "Payagan ang pagtatapos ng panahon ng pagboto",
                START_ENROLLMENT_PERIOD: "Simulan ang Panahon ng Pagpapatala",
                END_ENROLLMENT_PERIOD: "Panahon ng Pagpapatala",
                START_LOCKDOWN_PERIOD: "Simulan ang Lockdown Period",
                END_LOCKDOWN_PERIOD: "Tapusin ang Panahon ng Lockdown",
                ALLOW_TALLY: "Payagan ang tally",
            },
            election: {
                label: "Halalan",
            },
            empty: {
                header: "Wala pang Naka-schedule na Kaganapan.",
                body: "Gusto mo bang lumikha ng isa?",
                button: "Lumikha ng Naka-schedule na Kaganapan",
            },
            create: {
                title: "Lumikha ng Naka-schedule na Kaganapan",
                subtitle: "Lumikha ng bagong configuration ng Naka-schedule na Kaganapan.",
            },
            edit: {
                title: "I-edit ang Naka-schedule na Kaganapan",
                subtitle: "I-edit ang configuration ng Naka-schedule na Kaganapan.",
                delete: "Sigurado ka bang gusto mong tanggalin ang Naka-schedule na Kaganapan na ito?",
            },
            fields: {
                electionId: "Halalan",
                eventProcessor: "Uri",
                stoppedAt: "Huminto Noong",
                scheduledDate: "Naka-schedule Noong",
            },
        },
        reportsScreen: {
            title: "Mga Ulat",
            subtitle: "Lumikha ng mga ulat para sa mga kaganapan ng halalan",
            messages: {
                createSuccess: "Matagumpay na nalikha ang ulat",
                createError: "Nagkaroon ng error sa paglikha ng ulat",
                submitError: "Error sa pagsusumite ng Ulat",
                updateSuccess: "Matagumpay na na-update ang Ulat",
                passwordMismatch: "Ang password at confirm password ay hindi magkatugma. Siguraduhing pareho ang password sa dalawang field.",
                incorectPassword: "Maling password",
                decryptFileTitle: "Decrypt File",
                decryptInstructions: "1. '-in' : Ang path patungo sa naka-encrypt na file. \n2. '-out' : Ang path kung saan ise-save ang na-decrypt na file. \n3. '-pass' : Ang password na ginamit para i-encrypt ang file. \n",
                encryptSuccess: "Matagumpay na na-setup ang pag-encrypt ng ulat",
                encryptError: "Error sa pag-setup ng pag-encrypt ng ulat",
            },
            reportType: {
                BALLOT_RECEIPT: "Resibo ng Balota",
                ELECTORAL_RESULTS: "Mga Resulta ng Halalan",
                MANUAL_VERIFICATION: "Manwal na Pag-verify",
                PARTICIPATION_REPORT: "Ulat ng Pakikilahok",
                STATISTICAL_REPORT: "Ulat ng Istatistika",
                OVCS_EVENTS: "Pagsubaybay ng Botohan sa Ibang Bansa - Mga Kaganapan ng OVCS",
                AUDIT_LOGS: "Mga Talaan ng Awdit",
                ACTIVITY_LOG: "Mga Talaan ng aktibidad",
                STATUS: "Katayuan",
                OVCS_INFORMATION: "Impormasyon ng OVCS",
                OVERSEAS_VOTERS: "Listahan ng mga botanteng nasa ibang bansa",
                OV_USERS_WHO_VOTED: "Listahan ng mga Botanteng Nasa Ibang Bansa na Bumoto",
                OV_WITH_VOTING_STATUS: "Listahan ng mga Botanteng Nasa Ibang Bansa na may Katayuan sa Pagboto",
                OVCS_STATISTICS: "Pagsubaybay ng Botohan sa Ibang Bansa - Estadistika ng OVCS",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Listahan ng mga Botanteng Nasa Ibang Bansa na Naka-pre-enroll pero Hindi Naaprubahan",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Listahan ng mga Botanteng Nasa Ibang Bansa na Naka-pre-enroll pero Kailangan ng Manwal na Pagpapatunay",
            },
            reportEncryptionPolicy: {
                title: "Patakaran sa Encryption",
                UNENCRYPTED: "Hindi naka-encrypt",
                CONFIGURED_PASSWORD: "Nakakonfig na password",
            },
            empty: {
                header: "Wala pang mga ulat.",
                body: "Gusto mo bang lumikha ng isa?",
                button: "Lumikha ng Ulat",
            },
            create: {
                title: "Lumikha ng Ulat",
                subtitle: "Lumikha ng bagong konfigurasyon ng ulat.",
            },
            edit: {
                title: "I-edit ang Ulat",
                subtitle: "I-edit ang konfigurasyon ng ulat.",
                delete: "Sigurado ka bang nais mong tanggalin ang ulat na ito?",
            },
            fields: {
                electionId: "Halalan",
                template: "Template",
                reportType: "Uri ng Ulat",
                repeatable: "Nauulit",
                cronExpression: "Cron Expression",
                emailRecipients: "Mga Tatanggap ng Email",
                emailRecipientsPlaceholder: "I-type ang email at pindutin ang Enter",
            },
            delete: {
                body: "Sigurado ka bang nais mong tanggalin ang ulat na ito?",
            },
            actions: {
                generate: "Gumawa",
                delete: "Tanggalin",
                edit: "I-edit",
                preview: "I-preview",
            },
        },
        googleMeet: {
            title: "Bumuo ng Google Meet Link",
            generateButton: "Google Meet",
            meetingTitle: "Pamagat ng Meeting",
            description: "Paglalarawan (Opsyonal)",
            startDate: "Petsa ng Simula",
            startTime: "Oras ng Simula",
            duration: "Tagal (mga minuto)",
            attendeeEmails: "Mga Email ng mga Kalahok",
            attendeeEmailHelp: "Mga email na pinaghiwalay ng kuwit para sa mga kalahok sa meeting",
            note: "Paalala: Ito ay lilikha ng calendar event sa inyong Google Calendar na may Google Meet link. Kailangan ninyong mag-sign in sa inyong Google account.",
            success: "Matagumpay na Nabuo ang Google Meet Link!",
            copy: "Kopyahin sa clipboard",
            copied: "Nakopya na ang link sa clipboard!",
            instructions: "Ibahagi ang link na ito sa mga kalahok para sumali sa meeting. Naidagdag na ang calendar event sa inyong Google Calendar.",
            generating: "Bumubuo...",
            generate: "Bumuo ng Meet Link",
        },
        common: {
            export: "Maaaring magtagal ang pag-export. Sigurado ka bang nais mong i-export ang mga rekord?",
            resources: {
                electionEvent: "Kaganapan ng Halalan",
                election: "Halalan",
                contest: "Paligsahan",
                candidate: "Kandidato",
                noResult: {
                    askCreate: "Gusto mo bang lumikha ng isa?",
                },
            },
            label: {
                add: "Magdagdag",
                actions: "Mga Aksyon",
                create: "Lumikha",
                delete: "Tanggalin",
                archive: "I-archive",
                unarchive: "I-unarchive",
                cancel: "I-cancel",
                edit: "I-edit",
                yes: "Oo",
                no: "Hindi",
                save: "I-save",
                close: "Isara",
                back: "Bumalik",
                next: "Susunod",
                warning: "Babala",
                json: "Preview",
                noResult: "Walang resulta",
                import: "I-import",
                export: "I-export",
                loadingData: "Naga-load ng data...",
                exportFormat: "I-export sa format na {{format}} - Mga resulta ng '{{item}}",
                allResults: "kaganapan ng halalan",
                globalAreaResults: "lahat ng lugar",
                title: "Pamagat",
                subtitle: "Subtitle",
                kind: "Uri ng file",
                filter: "Pasadyang mga filter",
                approve: "Aprubahan",
                continue: "Magpatuloy",
                logout: "Mag-logout",
                selectTenant: "Pumili ng Tenant",
                processing: "Nagpro-process...",
                tenantName: "Pangalan ng Tenant",
            },
            language: {
                es: "Espanyol",
                en: "Ingles",
                fr: "Pranses",
                cat: "Valenciano",
                tl: "Tagalog",
                gl: "Galego",
                nl: "Nederlands",
                eu: "Euskera",
            },
            channel: {
                online: "Online",
                kiosk: "Kiosk",
                early_voting: "Maagang pagboto",
                telephone: "Pagboto sa Telepono",
                other: "Iba pa",
            },
            message: {
                delete: "Sigurado ka bang gusto mong tanggalin ang item na ito?",
                continueOrLogout: "Gusto mo bang magpatuloy o mag-logout?",
            },
        },
        createResource: {
            electionEvent: "Lumikha ng Kaganapan ng Halalan",
            election: "Lumikha ng Halalan",
            contest: "Lumikha ng Paligsahan",
            candidate: "Lumikha ng Kandidato",
            slate: "Gumawa ng Slate",
        },
        importResource: {
            electionEvent: "Mag-import ng Kaganapan ng Halalan",
            election: "Mag-import ng Halalan",
            contest: "Mag-import ng Paligsahan",
            candidate: "Mag-import ng Kandidato",
            ImportHashMismatch: "Hindi tugma ang mga hash. Nabigo ang pagsusuri ng integridad.",
        },
        sideMenu: {
            electionEvents: "Mga Kaganapan ng Halalan",
            search: "Maghanap",
            usersAndRoles: "Mga Tagagamit at Tungkulin",
            logs: "Mga Log",
            settings: "Mga Setting",
            help: "Tulong",
            templates: "Mga template",
            active: "Aktibo",
            archived: "Arkilado",
            addResource: {
                electionEvent: "Lumikha ng Kaganapan ng Halalan",
                election: "Lumikha ng Halalan",
                contest: "Lumikha ng Paligsahan",
                candidate: "Lumikha ng Kandidato",
            },
            menuActions: {
                archive: {
                    electionEvent: "I-archive ang Kaganapan ng Halalan",
                },
                unarchive: {
                    electionEvent: "I-unarchive ang Kaganapan ng Halalan",
                    election: "I-unarchive ang Halalan",
                    contest: "I-unarchive ang Paligsahan",
                    candidate: "I-unarchive ang Kandidato",
                },
                remove: {
                    electionEvent: "Tanggalin ang Kaganapan ng Halalan",
                    election: "Tanggalin ang Halalan",
                    contest: "Tanggalin ang Paligsahan",
                    candidate: "Tanggalin ang Kandidato",
                    slate: "Alisin ang Slate na ito",
                },
                messages: {
                    confirm: {
                        archive: "Sigurado ka bang i-archive ang item na ito?",
                        unarchive: "Sigurado ka bang i-unarchive ang item na ito?",
                        delete: "Sigurado ka bang tanggalin ang item na ito?",
                        archiveNamed: 'Sigurado ka bang i-archive ang "{{name}}"?',
                        unarchiveNamed: 'Sigurado ka bang i-unarchive ang "{{name}}"?',
                        deleteNamed: 'Sigurado ka bang tanggalin ang "{{name}}"?',
                    },
                    notification: {
                        success: {
                            archive: "Ang item ay na-archive na",
                            unarchive: "Ang item ay na-unarchive na",
                            delete: "Ang item ay natanggal na",
                            reloading: "Wait. Ang pahina ay na-reload na sa iba pang mga oras.",
                        },
                        error: {
                            archive: "Error habang sinusubukang i-archive ang item na ito",
                            unarchive: "Error habang sinusubukang i-unarchive ang item na ito",
                            delete: "Error habang sinusubukang tanggalin ang item na ito",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Pag-configure ng Kandidato",
            },
            edit: {
                externalId: "Panlabas na ID",
                general: "Pangkalahatan",
                type: "Uri",
                image: "Larawan",
                isDisabled: "Hindi Aktibo",
                isExplicitInvalid: "Di-wastong Boto",
                isExplicitBlank: "Blangkong Boto",
                isCategoryList: "Listahan ng Kategorya",
                isWriteIn: "Sinusulat na boto",
            },
            field: {
                name: "Pangalan",
                alias: "Alias",
                description: "Deskripsyon",
            },
            options: {
                "candidate": "Kandidato",
                "option": "Opsyon",
                "write-in": "Sinusulat na boto",
                "open-list": "Bukas na Listahan",
                "closed-list": "Saradong Listahan",
                "semi-open-list": "Semi Bukas na Listahan",
                "invalid-vote": "Di-wastong Boto",
                "blank-vote": "Blangkong Boto",
            },
            invalidVotePosition: {
                label: "Posisyon ng Di-wastong Boto",
                null: "Wala (Default)",
                top: "Taas",
                bottom: "Baba",
            },
            error: {},
            createCandidateSuccess: "Kandidato ay nalikha",
            createCandidateError: "Error sa paglikha ng kandidato",
        },
        slateScreen: {
            common: {
                subtitle: "Configuration ng slate.",
                newSlate: "Bagong slate",
                notFound: "Walang ganitong slate.",
            },
            tabs: {
                data: "Datos",
            },
            edit: {
                general: "Pangkalahatan",
                members: "Mga Miyembro",
            },
            field: {
                name: "Pangalan",
                alias: "Alyas",
                description: "Paglalarawan",
                externalId: "External ID",
            },
            members: {
                helper: "Magtalaga ng mga kandidato hanggang sa pinakamataas na bilang ng bawat paligsahan. Iwanang walang laman ang isang paligsahan para walang kandidato ang slate na ito roon. Ang mga kandidatong wala sa anumang slate ay lalabas bilang Independiyente sa paligsahang iyon.",
                contest: "Paligsahan",
                candidate: "Kandidato",
                noCandidate: "Walang kandidato",
            },
            messages: {
                saved: "Na-save ang slate",
                invalid: "Hindi ma-save ang slate. Ayusin ang mga problemang nakalista sa ibaba.",
                error: "Hindi na-save ang slate.",
                unreadable: "Hindi mabasa ang configuration ng mga slate ng halalan.",
            },
        },
        contestScreen: {
            common: {
                subtitle: "Pag-configure ng Paligsahan",
            },
            edit: {
                externalId: "Panlabas na ID",
                general: "Pangkalahatan",
                type: "Uri",
                image: "Larawan",
                system: "Sistema ng Pagboto sa Balota",
                design: "Disenyo ng Balota",
                reorder: "I-reorder ang mga kandidato",
                policies: "Mga Patakaran",
            },
            field: {
                name: "Pangalan",
                alias: "Alias",
                description: "Deskripsyon",
            },
            options: {
                "non-preferential": "Walang Preferensyal",
                "plurality-at-large": "Pluralidad sa Lahat",
                "instant-runoff": "Instant Runoff",
                "random": "Random",
                "external-procedure": "Panlabas na pamamaraan",
                "custom": "Pasadya",
                "alphabetical": "Alpabetikal",
            },
            tieBreakingPolicy: {
                label: "Patakaran sa Tie-Breaking",
            },
            auditButtonConfig: {
                "label": "Mga Opsyon sa Pagpahiling kan Buton nin Pag-audit",
                "show": "Ipahiling",
                "not-show": "Dai Ipahiling",
                "show-in-help": "Ipahiling an Help Dialog",
            },
            underVotePolicy: {
                "label": "Sa irarom kan Patakaran sa Pagboto",
                "allowed": "Tinogotan",
                "warn-only-in-review": "Magbabala sa pagsusuri",
                "warn": "Patanid",
                "warn-and-alert": "Patanid asin Alerto",
                "warn-and-confirm-in-review": "Magbabala at kumpirmahin sa pagsusuri",
            },
            invalidVotePolicy: {
                "label": "Patakaran sa walang boto",
                "allowed": "Pinapayagan",
                "warn": "Magbigay ng Babala",
                "warn-invalid-implicit-and-explicit": "Magbigay ng Babala sa Di-wastong Implicit at Explicit",
                "not-allowed": "Hindi Pinapayagan",
                "allowed-with-exclusive-explicit": "Pinapayagan na may Eksklusibong Di-wastong Boto",
            },
            candidatesIconCheckboxPolicy: {
                "label": "An porma kan icon kan kahon kan mga kandidato",
                "square-checkbox": "Parisukat na checkbox",
                "round-checkbox": "Bilog na Kahon nin Tsek",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Mga Kandidato at Listahan",
                "allow-selecting-candidates": "Mga Kandidato Lamang",
                "allow-selecting-lists": "Mga Listahan Lamang",
                "disabled": "Hindi Aktibo",
            },
            collapsibleListsPolicy: {
                "label": "Natatiklop na mga listahan",
                "disabled": "Hindi pinagana",
                "enabled-expanded": "Pinagana (nagsisimulang nakalawak)",
                "enabled-collapsed": "Pinagana (nagsisimulang nakatiklop)",
            },
            blankVotePolicy: {
                "label": "Patakaran sa walang boto",
                "allowed": "Pinapayagan",
                "warn-only-in-review": "Magbigay ng babala sa Pagsusuri",
                "warn": "Magbigay ng babala",
                "not-allowed": "Hindi pinapayagan",
            },
            overVotePolicy: {
                "label": "Patakaran sa Sobra sa Pagboto",
                "allowed": "Tinogotan",
                "allowed-with-msg": "Tinutugot sa Mensahe nin Patanid",
                "allowed-with-msg-and-alert": "Tinutugotan sa mensahe nin Patanid asin Alerto",
                "not-allowed-with-msg-and-alert": "Dai Tinotogotan an mensahe nin Patanid asin Alerto",
                "not-allowed-with-msg-and-disable": "Dai Tinutugutan an mensahe nin Patanid asin I-disable an mga dugang pang pagpili",
            },
            duplicatedRankPolicy: {
                "label": "Di-wastong Boto - Patakaran sa Dobleng Ranggo",
                "allowed-warn-and-dialog": "Ipakita ang babala at dialog (maaaring magpatuloy ang botante)",
                "not-allowed-warn-and-dialog": "Ipakita ang babala at dialog (hindi maaaring magpatuloy ang botante)",
            },
            preferenceGapsPolicy: {
                "label": "Di-wastong Boto - Patakaran sa Nilaktawang Ranggo",
                "allowed-warn-and-dialog": "Ipakita ang babala at dialog (maaaring magpatuloy ang botante)",
                "not-allowed-warn-and-dialog": "Ipakita ang babala at dialog (hindi maaaring magpatuloy ang botante)",
            },
            paginationPolicy: {
                label: "Pangalan ng Pahina",
            },
            isAcclaimed: {
                label: "Napagpasyahan sa pamamagitan ng aklamasyon",
                helperText: "Nakikita ng mga botante ang paligsahang ito ngunit walang mapipili, walang naitatala, at lahat ng kandidato ay iniuulat na nanalo na may zero na boto. Itakda ito bago ilathala ang mga balota: ang pagbabago pagkatapos ay magpapawalang-bisa sa mga balotang naisumite na.",
            },
            allowWriteins: {
                label: "Payagan ang Mga Manu-manong Kandidato",
            },
            maxVotes: {
                helperText: "Pinakamataas na bilang ng mga kandidatong maaaring piliin ng botante (hindi-kagustuhang pagboto).",
                helperTextPreferential: "Pinakamataas na posisyon ng ranggo na magagamit (hal. '5' ay nagbibigay ng mga posisyon 1–5). Dapat na hindi bababa sa bilang ng mga kandidatong irurango (kagustuhang pagboto).",
            },
            error: {},
            createContestSuccess: "Paligsahan ay nalikha",
            createContestError: "Error sa paglikha ng paligsahan",
        },
        keysGeneration: {
            configureStep: {
                create: "Lumikha ng Seremonya ng Mga Susi",
                name: "Pangalan ng Seremonya ng mga Susi",
                allElections: "Lahat ng Halalan",
                title: "Lumikha ng Seremonya ng Mga Susi para sa Kaganapan sa Halalan",
                subtitle: "Sa Seremonya ng Mga Susi, bawat trustee ay lilikha at magda-download ng kanilang piraso ng pribadong susi para sa Kaganapan sa Halalan. Upang magpatuloy, mangyaring pumili ng mga trustee na lalahok sa seremonya at ang threshold, na siyang minimum na bilang ng mga trustee na kinakailangan upang magbilang.",
                threshold: "Threshold",
                trusteeList: "Mga Trustee",
                errorMinTrustees_one: "Pumili ka lamang ng {{selected}} trustee, ngunit kailangan mong pumili ng hindi bababa sa {{threshold}}.",
                errorMinTrustees_many: "Pumili ka lamang ng {{selected}} mga trustee, ngunit kailangan mong pumili ng hindi bababa sa {{threshold}}.",
                errorMinTrustees_other: "Pumili ka lamang ng {{selected}} mga trustee, ngunit kailangan mong pumili ng hindi bababa sa {{threshold}}.",
                errorThreshold: "Pumili ka ng threshold {{selected}} ngunit ito ay dapat na nasa pagitan ng {{min}} at {{max}}.",
                errorCreatingCeremony: "Error sa paglikha ng Seremonya ng Mga Susi: {{error}}",
                createCeremonySuccess: "Seremonya ng Mga Susi ay nalikha",
                confirmdDialog: {
                    ok: "Oo, Lumikha ng Seremonya ng Mga Susi",
                    cancel: "Kanselahin",
                    title: "Sigurado ka bang nais mong lumikha ng Seremonya ng Mga Susi?",
                    automaticCeremonyTitle: "Sigurado ka bang gusto mong lumikha ng isang Awtomatikong Seremonya ng mga Susi?",
                    description: "Ikaw ay malapit nang lumikha ng Seremonya ng Mga Susi. Ang aksyong ito ay magpapadala ng abiso sa mga Trustee upang lumahok sa paglikha at pamamahagi ng Mga Susi ng Kaganapan sa Halalan.",
                    automaticCeremonyDescription: "Ikaw ay lilikha ng isang Awtomatikong Seremonya ng mga Susi. Hindi nito aabisuhan ang mga Trustee na lumahok.",
                },
                filterTrustees: "I-filter ang mga trustee",
                errorPermisionLabels: "Hindi maipagawa ang keys ceremony: may nawawala sa isa o higit pang permission label.",
                automaticCeremonyToggle: "Awtomatikong Seremonya",
            },
            ceremonyStep: {
                cancel: "Kanselahin ang Seremonya ng Mga Susi",
                progressHeader: "Pag-andar ng Seremonya ng Mga Susi",
                description: "Ipinapakita ng screen na ito ang pag-andar at mga tala ng Seremonya ng Mga Susi ng Kaganapan sa Halalan. Sa Seremonya ng Mga Susi, bawat trustee ay lilikha at magda-download ng kanilang piraso ng pribadong susi para sa Kaganapan sa Halalan.",
                executionStatus: "Katayuan: {{status}}",
                confirmdDialog: {
                    ok: "Oo, Kanselahin ang Paglikha ng Seremonya ng Mga Susi",
                    cancel: "Bumalik sa Seremonya ng Mga Susi",
                    title: "Sigurado ka bang nais mong kanselahin ang Seremonya ng Mga Susi?",
                    description: "Malapit mo nang ma-kansela ang Seremonya ng Mga Susi. Pagkatapos isagawa ang aksyong ito, upang magkaroon ng matagumpay na Seremonya ng Mga Susi, kailangan mong lumikha ng bago.",
                },
                header: {
                    trusteeName: "Pangalan ng Trustee",
                    fragment: "Nalikha ang Piraso ng Susi",
                    downloaded: "Nai-download na Piraso ng Pribadong Susi",
                    checked: "Nasuri ang Piraso ng Pribadong Susi",
                },
                logsHeader: {
                    title: "Mga Tala",
                    date: "Petsa",
                    entry: "Entry",
                },
                emptyLogs: "Wala pang tala.",
            },
            startStep: {
                title: "Seremonya ng Mga Susi ng Trustee",
                subtitle: "Ikaw ay malapit nang lumahok sa Seremonya ng Mga Susi bilang isang Trustee (<strong>{{name}}</strong>). Kasama sa mga hakbang ang mga sumusunod:",
                one: "<strong>I-download</strong> ang iyong Encrypted Private Key.",
                two: "Lumikha ng maraming <strong>Backup</strong> ng Encrypted Private Key.",
                three: "<strong>Surii</strong> na ang mga backup ay maayos na gumagana.",
            },
            downloadStep: {
                title: "I-download ang Encrypted Private Key",
                subtitle: "Upang magpatuloy, mangyaring i-download at itago ang iyong Encrypted Private Key sa hindi bababa sa dalawang magkaibang device:",
                downloadButton: "I-download ang iyong Encrypted Private Key",
                downloaded: "Matagumpay na na-download ang Encrypted Private Key.",
                errorEmptyKey: "Error sa pag-download, walang laman na file",
                unexpectedError: "Hindi ma-download ang pribadong key. Pakisubukang muli.",
                alreadyVerified: "Na-download at na-verify na ang iyong pribadong key.",
                unavailable: "Hindi na maaaring i-download ang pribadong key dahil nagpatuloy na ang seremonya.",
                confirmdDialog: {
                    ok: "Kumpirmahin ang mga Backup at Magpatuloy",
                    cancel: "Bumalik",
                    title: "I-backup ang iyong Encrypted Private Key",
                    description: "Mangyaring i-backup ang iyong Encrypted Private Key sa hindi bababa sa dalawang magkaibang ligtas na lokasyon at pagkatapos ay kumpirmahin ito sa ibaba:",
                    firstCopy: "Unang backup ay ligtas",
                    secondCopy: "Ikalawang backup ay ligtas",
                    confirmError: "Gumawa ng mga kinakailangang backup at lagyan ng tsek ang mga kahon ng kumpirmasyon upang magpatuloy",
                },
            },
            checkStep: {
                title: "Suriin ang Iyong Encrypted Private Key Backups",
                verifyButton: "Beripikahin ang key",
                subtitle: "I-upload ang isang Backup ng Encrypted Private Key upang suriin kung ito ay tama. Maaari mong subukan ng maraming beses hangga't kinakailangan, mula sa iyong iba't ibang backups:",
                errorUploading: "Di-wastong Encrypted Private Key Backup, mangyaring subukan muli",
                errorEmptyFile: "Walang laman na file o hindi natagpuan",
                verified: "Backup ay matagumpay na nasuri.",
                alreadyRestored: "Naibalik na ang iyong key.",
            },
        },
        miruExport: {
            create: {
                success: "Nilikha ang Transmission Package...",
                error: "Error sa paglikha ng Transmission Package",
            },
            send: {
                success: "Ipinapadala ang Transmission Package...",
                error: "Error sa pagpapadala ng Transmission Package",
            },
        },
        tally: {
            numericResultsReportsPending: "Kumpleto na ang mga numerikong resulta. Ginagawa pa ang mga ulat.",
            errorUploadingSignature: "Nagkaroon ng error sa pag-upload ng pirma",
            downloadTransmissionPackage: "I-download ang pakete",
            resultsPublication: {
                sectionTitle: "I-publish sa website ng mga resulta",
                policyTitle: "Website ng mga resulta",
                policyAccess: "Pag-access sa website ng mga resulta",
                policyVisibility: "Visibility ng website ng mga resulta",
                enabled: "Naka-enable",
                disabled: "Naka-disable",
                fullEvent: "Buong kaganapan",
                areaBased: "Batay sa lugar",
                publishStarted: "Nagsimula ang paglalathala ng mga resulta",
                publishError: "Hindi masimulan ang paglalathala ng mga resulta",
                revoked: "Nabawi ang paglalathala ng mga resulta",
                revokeError: "Hindi mabawi ang paglalathala ng mga resulta",
                waitingForTally: "Maaaring i-publish ang mga resulta pagkatapos makumpleto ang pagbibilang na ito.",
                writePermissionRequired: "Kailangan mo ang pahintulot na publish-results-write para mag-publish o bumawi ng mga resulta.",
                readPermissionRequired: "Kailangan mo ang pahintulot na publish-results-read para tingnan ang kasaysayan ng paglalathala.",
                disabledPolicy: "Naka-disable ang pag-publish sa website ng mga resulta para sa kaganapang ito ng halalan. I-enable ito sa data ng kaganapan ng halalan bago i-publish ang mga resulta.",
                loadingElectionContext: "Nilo-load ng paglalathala ng mga resulta ang konteksto ng halalan.",
                route: "Ruta",
                eventResults: "Mga resulta ng kaganapan",
                electionResults: "Mga resulta ng halalan",
                election: "Halalan",
                access: "Pag-access",
                publicAccess: "Pampublikong pag-access",
                authenticatedAccess: "Naka-authenticate na pag-access",
                visibility: "Visibility",
                fullPublishedScope: "Buong nailathalang saklaw",
                personalVisibility: "Personal na visibility",
                contests: "Mga Paligsahan",
                noTalliedContests: "Walang available na mga naibilang na paligsahan.",
                publishSelectedContests: "I-publish ang mga napiling paligsahan",
                selectedContestCount_one: "{{count}} paligsahan ang napili",
                selectedContestCount_many: "{{count}} paligsahan ang napili",
                selectedContestCount_other: "{{count}} paligsahan ang napili",
                history: "Kasaysayan ng paglalathala",
                version: "Bersyon",
                status: "Katayuan",
                published: "Nailathala",
                revokedAt: "Nabawi",
                actions: "Mga aksyon",
                open: "Buksan",
                revoke: "Bawiin",
                noPublications: "Wala pang mga paglalathala.",
                confirmTitle: "Simulan ang pag-publish sa website ng mga resulta?",
                confirmDescription: "Gagawa ito ng bagong paglalathala mula sa kasalukuyang pagbibilang. Mananatiling aktibo ang kasalukuyang mga resulta para sa mga botante hanggang magtagumpay ang gawaing ito ng pag-publish.",
                close: "Isara",
            },
            transmissionPackage: {
                title: "Pakete ng Transmisyon para sa Lugar '{{name}}' at Halalan na '{{eventName}}'",
                description: "Hinahayaan kang i-export ang isang Pakete ng Transmisyon sa mga Server ng Destinasyon o i-download ito.",
                actions: {
                    sign: {
                        title: "I-regenerate",
                        dialog: {
                            title: "Nais mo bang pirmahan ang pakete ng transmisyon?",
                            description: "Pakisiguro na nais mong i-regenerate ang pakete ng transmisyon para sa lugar na `{{name}}`",
                            confirm: "Pirmahan ang pakete ng transmisyon",
                            cancel: "Isara",
                            input: {
                                placeholder: "Ilagay ang iyong password",
                            },
                        },
                    },
                    send: {
                        title: "Ipadala",
                        dialog: {
                            title: "Gusto mo bang ipadala ang Pakete ng Transmisyon?",
                            description: "Pakisiguro na nais mong ipadala ang Pakete ng Transmisyon para sa Lugar '{{name}}' sa mga Server ng Destinasyon.",
                            confirm: "Ipadala ang Pakete ng Transmisyon",
                            cancel: "Isara",
                        },
                    },
                    regenerate: {
                        title: "I-regenerate",
                        dialog: {
                            title: "Nais mo bang i-regenerate ang pakete ng transmisyon?",
                            description: "Pakisiguro na nais mong i-regenerate ang pakete ng transmisyon para sa lugar na `{{name}}`",
                            confirm: "I-regenerate ang pakete ng transmisyon",
                            cancel: "Isara",
                        },
                    },
                    download: {
                        title: "I-download",
                        emlTitle: "I-download ang EML {{date}}",
                        transmissionPackageTitle: "I-download ang Pakete ng Transmisyon {{date}}",
                        transmissionReportTitle: "I-download ang Ulat ng Transmisyon",
                        dialog: {
                            title: "Gusto mo bang i-download ang Pakete ng Transmisyon?",
                            description: "Pakisiguro na nais mong i-download ang Pakete ng Transmisyon para sa Lugar '{{name}}.'",
                            confirm: "I-download ang Pakete ng Transmisyon",
                            cancel: "Isara",
                        },
                    },
                },
                destinationServers: {
                    title: "Mga Server ng Destinasyon",
                    description: "Ipinapakita ng talahanayan sa ibaba ang katayuan ng pagpapadala sa bawat isa sa mga Server ng Destinasyon.",
                    status: "Naipadala sa {{signed}} ng {{total}}",
                    table: {
                        serverName: "Pangalan ng Server",
                        sendStatus: "Katayuan ng Pagpapadala",
                    },
                },
                signatures: {
                    title: "Mga lagda ng SBEI",
                    description: "Maaaring pirmahan ng mga SBEI ang Pakete ng Transmisyon. Ipinapakita ng talahanayan sa ibaba ang katayuan ng pirma ng bawat isa sa mga miyembro ng SBEI.",
                    table: {
                        trusteeName: "ID ng SBEI",
                        signed: "Napirmahan",
                    },
                    status: "{{signed}} sa {{total}} Napirmahan, minimum {{minimum}}",
                },
            },
            sendToTransmissionPackageServers: "Ipadala ang pakete ng transmisyon para sa lugar '{{name}}'",
            uploadTransmissionPackage: "I-upload",
            uploadTransmissionPackageDesc: "I-upload ang iyong pirma para pirmahan ang pakete ng Resulta ng Halalan. Ang operasyong ito ay opsyonal.",
            exportElectionArea: "Ipadala ang pakete ng transmisyon para sa lugar '{{name}}'",
            generateReport: "Bumuo ng {{name}}",
            templateTitle: "Template ng Resulta",
            templateSubTitle: "Opsyonal na palitan ang template ng mga resulta.",
            keysCeremonyTitle: "Seremonya ng mga Susi",
            keysCeremonySubTitle: "Piliin ang Seremonya ng mga Susi para sa pagbilang na ito",
            ceremonyTitle: "Halalan para sa Pagbibilang",
            initializationTitle: "Halalan para sa Ulat ng Inisyal na Pagsisimula",
            ceremonySubTitle: "Piliin ang halalan para sa pagbibilang",
            tallyTitle: "Progreso ng Pagbibilang ng Halalan",
            logsTitle: "Mga Logs",
            resultsTitle: "Mga Resulta at Pakikilahok",
            generalInfoTitle: "Pangkalahatang Impormasyon",
            trusteeTallyTitle: "Tagapagtiwala",
            trusteeTallySubTitle: "Katayuan ng pag-import ng fragment ng key",
            eligibility: {
                selectElection: "Pumili ng kahit isang halalan.",
                publishElection: "I-publish ang bawat napiling halalan bago gumawa ng pagbibilang nito.",
                tallyDisallowed: "Hindi pinapayagan ang pagbibilang para sa isang napiling halalan.",
                endVoting: "Tapusin ang pagboto sa bawat napiling halalan at ihinto ang mga aktibong channel bago gumawa ng pagbibilang.",
            },
            createTallySuccess: "Pagbibilang na ginawa",
            createTallyError: "Error sa paggawa ng pagbibilang",
            startTallySuccess: "Nagsimula ang pagbibilang",
            startTallyError: "Error sa pagsisimula ng pagbibilang",
            startTallyCeremonySuccess: "Nagsimula ang seremonya ng pagbibilang",
            startTallyCeremonyError: "Hindi nasimulan ang seremonya ng pagbibilang",
            cancelTallyCeremonySuccess: "Nakansela ang seremonya ng pagbibilang",
            cancelTallyCeremonyError: "Hindi nakansela ang seremonya ng pagbibilang",
            recountTallyCeremony: "Muling pagbibilang",
            recountTallyCeremonyMessage: "Gagawa ito ng bagong resulta para sa natapos na sesyon ng pagbibilang.",
            recountTallyCeremonyStarting: "Sinisimulan ang muling pagbibilang...",
            recountTallyCeremonySuccess: "Nagsimula ang muling pagbibilang",
            recountTallyCeremonyError: "Hindi nasimulan ang muling pagbibilang",
            recountTallyCeremonyOk: "Muling bilangin",
            trusteeTitle: "Proseso ng tagapagtiwala",
            trusteeSubTitle: "Pakilagay ang iyong fragment ng key",
            invited: "Naanyayahan kang lumahok sa isang seremonya ng pagbibilang. Pakisuyo, ",
            click: "i-click ang aksyon ng pagbibilang",
            participate: "para lumahok.",
            breadcrumbSteps: {
                start: "Simula",
                finish: "Tapos",
                tally: "Pagbibilang",
                results: "Mga Resulta",
                ceremony: "Seremonya",
            },
            common: {
                title: "Pagbibilang",
                subTitle: "Pag-setup ng Pagbibilang.",
                cancel: "Bumalik",
                next: "Susunod",
                date: "Petsa ng Pagbibilang",
                global: "Lahat ng lugar",
                noTrustees: "Walang mga tagapagtiwala pa",
                imported: " tagapagtiwala ang nag-import ng kanilang fragment ng key",
                needed: " tagapagtiwala ang kailangan para sa pagbibilang",
                start: "Simulan ang Pagbibilang",
                ceremony: "Simulan ang Seremonya ng Pagbibilang",
                initialization: "Simulan ang Ulat ng Inisyal na Pagsisimula",
                results: "Mga Resulta",
                dialog: {
                    ok: "Ok",
                    okTally: "Simulan ang pagbibilang",
                    okCancel: "Kanselahin ang pagbibilang",
                    cancel: "Isara",
                    title: "Sigurado ka bang gusto mong simulan ang isang seremonya?",
                    tallyTitle: "Sigurado ka bang gusto mong simulan ang pagbibilang?",
                    cancelTitle: "Sigurado ka bang gusto mong kanselahin ang pagbibilang?",
                    message: "Malapit ka nang magsimula ng isang seremonya ng pagbibilang. Aabisuhan nito ang mga tagapagtiwala para i-import ang kanilang mga fragment ng key.",
                    cancelMessage: "Malapit ka nang kanselahin ang seremonya ng pagbibilang. Hindi na mababawi ang aksyong ito.",
                    ceremony: "Na-verify na ng lahat ng kinakailangang tagapagtiwala ang kanilang mga fragment ng key. Handa na ang lahat para simulan ang pagtanggap ng mga resulta. Nais mo bang simulan ang Pagbibilang?",
                    startAutomatedTallyMessage: "Piliin ang 'Start Tally' upang patakbuhin ang proseso ng pagbilang at ipakita ang mga resulta, o 'Close' upang kanselahin.",
                },
            },
            table: {
                elections: "Halalan",
                selected: "Napili",
                status: "Katayuan",
                progress: "Progreso",
                method: "Pamamaraan ng Pagbibilang",
                elegible: "Mga Karapat-dapat na Botante",
                number: "Bilang ng mga Boto",
                total: "Kabuuan",
                turnout: "%",
                candidates: "Mga Resulta ng Kandidato",
                options: "Mga Opsyon",
                global: "Buod ng pakikilahok",
                elegible_census: "Senso ng mga karapat-dapat na botante",
                cast_votes: "Bilang ng mga Boto",
                cast_votes_percent: "Porsyento ng mga Boto",
                total_votes: "Kabuuang mga botante",
                total_votes_percent: "Pakikilahok",
                total_votes_counted: "Kabuuang mga Botong Nabilang",
                total_auditable_votes: "Kabuuang Mga Botong Maaaring Ma-audit",
                total_valid_votes: "Kabuuang mga balidong boto",
                total_valid_votes_percent: "Porsyento ng balidong boto",
                total_invalid_votes: "Kabuuang mga di-balidong boto",
                total_invalid_votes_percent: "Porsyento ng mga di-balidong boto",
                explicit_invalid_votes: "Mga hayag na di-balidong boto",
                explicit_invalid_votes_percent: "Porsyento ng mga hayag na di-balidong boto",
                implicit_invalid_votes: "Mga nakatagong di-balidong boto",
                implicit_invalid_votes_percent: "Porsyento ng mga nakatagong di-balidong boto",
                blank_votes: "Mga botong walang laman",
                explicit_blank_votes: "Mga hayag na blankong boto",
                implicit_blank_votes: "Mga nakatagong blankong boto",
                blank_votes_percent: "Porsyento ng mga botong walang laman",
                number_of_votes: "Bilang ng mga boto",
                winning_position: "Panalong posisyon",
                weight: "Timbang",
                preferential: {
                    candidate: "Kandidato",
                    winner: "Nanalo",
                    eliminated: "Naalis",
                    round: "Ikot",
                },
                total_declined_to_vote: "Kabuuang Tumangging Bumoto",
                total_blank_ballots: "Kabuuang Blangkong Balota",
                participation_by_channel: "Paglahok ayon sa channel",
                channel: "Channel",
                channel_online: "Online",
                channel_kiosk: "Kiosk",
                channel_early_voting: "Maagang pagboto",
                channel_telephone: "Telepono",
                channel_paper: "Papel",
                channel_postal: "Koreo",
                channel_in_person: "Personal",
                acclamation_note: "Nanalo sa pamamagitan ng aklamasyon. Ang paligsahang ito ay napagpasyahan nang walang botohan, kaya walang naitalang boto.",
            },
            pendingResolutions: {
                round: "Ikot {{round}}",
                tieResolutionRequired: "Kinakailangan ang resolusyon sa ugnayan",
                tieResolved: "Naresolba ang ugnayan",
                globalArea: "Lahat ng lugar",
                pendingResolutionsHeader: "Mga nakabinbing resolusyon",
                pendingResolutionStatus: "Nakabinbing resolusyon",
                resolvedStatus: "Naresolba",
                resolutionTitle: "Resolusyon",
                selectContest: "Pumili ng aytem sa kaliwa upang tingnan ang mga detalye",
                selectCandidateToAdvance: "Piliin ang kandidatong itataguyod",
                undoResolution: "I-undo ang resolusyon",
                applyResolutions: "Ilapat ang mga resolusyon at muling kalkulahin",
                submitSuccess: "Mga resolusyon isinumite. Ang pagbibilang ay nagpapatuloy...",
                submitError: "Nabigo ang pag-isumite ng mga resolusyon. Pakisubukan muli.",
                filter: "I-filter",
                save: "I-save",
                pendingApplyStatus: "Nakabinbing kalkulasyon",
                filterElection: "Halalan",
                filterContest: "Paligsahan",
                filterArea: "Lugar",
                filterStatusLabel: "Katayuan",
                clearFilters: "I-clear ang mga filter",
                candidateWithVotes: "{{name}} ({{votes}} boto)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} boto, {{percent}}%)",
                tieInfoTitle: "Ang pagbibilang ay natigil dahil sa hindi naresolubasiyong ugnayan (Ikot {{round}})",
                tieInfoBody: "Mga kandidatong nagtatali ({{votes}} boto, {{percent}}%): {{candidates}}. Kinakailangan ang manu-manong pagpili para magpatuloy ang pagbibilang.",
                tallyResumedTitle: "Nagpapatuloy na ang pagbibilang pagkatapos ilapat ang resolusyon",
                tallyResumedBody: "Ang ugnayan ay nalutas noong {{date}} ni {{user}}",
            },
            chart: {
                votesForCandidates: "Mga Boto para sa mga Kandidato",
                blankVotes: "Mga Blankong Boto",
                invalidVotes: "Mga Hindi Wastong Boto",
                totalVoters: "Kabuuang mga Botante",
                nonVoters: "Hindi Bumoto",
            },
            exportAllAreas: "I-export ang resulta ng lahat ng lugar sa format na {{format}} para kay '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Piliin ang Lugar para sa Preview",
                action: "Preview",
                copy: "Kopyahin ang link",
                copy_success: "Tagumpay sa pagkopya ng link ng preview",
                copy_error: "Nabigong kopyahin ang link ng preview",
                success: "Matagumpay na pagbukas ng preview",
            },
            header: {
                change: "Mga Pagbabago na Ilalathala",
                viewChange: "Tingnan ang Paglalathala",
                history: "Kasaysayan ng Paglalathala",
            },
            action: {
                generateInitializationReport: "Gumawa ng Ulat sa Inisyal na Pagsisimula",
                startVotingPeriod: "Simulan ang Pagboto",
                startKioskVoting: "Simulan ang Pagboto sa Kiosk",
                startOnlineVoting: "Simulan ang Pagboto Online",
                startEarlyVoting: "Simulan ang Maagang Pagboto",
                startTelephoneVoting: "Simulan ang Telepono Pagboto",
                stopVotingPeriod: "Itigil ang Pagboto",
                stopOnlineVoting: "Itigil ang Pagboto Online",
                stopEarlyVoting: "Itigil ang Maagang Pagboto",
                stopTelephoneVoting: "Itigil ang Telepono Pagboto",
                stopKioskVotingPeriod: "Itigil ang Pagboto sa Kiosk",
                pauseVotingPeriod: "I-pause ang Pagboto",
                pauseKioskVoting: "I-pause ang Pagboto sa Kiosk",
                pauseOnlineVoting: "I-pause ang Pagboto Online",
                pauseEarlyVoting: "I-pause ang Maagang Pagboto",
                pauseTelephoneVoting: "I-pause ang Telepono Pagboto",
                generate: "Muling Lumikha",
                publish: "Ilathala ang Mga Pagbabago",
                back: "Bumalik",
            },
            label: {
                current: "Kasalukuyan",
                previous: "Nakaraang Paglalathala",
                publication: "Paglalathala",
                diff: "Mga Pagbabago na Ilalathala",
            },
            empty: {
                header: "Walang Paglalathala Pa.",
                action: "Lumikha ng Paglalathala",
            },
            forbidden: {
                header: "Hindi mai-publish hanggang sa makumpleto ang Keys Ceremony.",
            },
            dialog: {
                title: "Kumpirmahin ang Aksyon",
                info: "Ikaw ay nag-click sa isang sensitibong aksyon, kaya't kailangan namin ng iyong kumpirmasyon upang magpatuloy",
                initializationInfo: "Malapit ka nang bumuo ng ulat ng inisyalisasyon. Sigurado ka bang gusto mong magpatuloy?",
                startInfo: "Malapit mo nang simulan ang panahon ng pagboto. Sigurado ka bang nais mong magpatuloy?",
                stopInfo: "Malapit mo nang itigil ang panahon ng pagboto. Sigurado ka bang nais mong magpatuloy?",
                kioskStopInfo: "Malapit mo nang itigil ang panahon ng pagboto sa kiosk. Sigurado ka bang gusto mong magpatuloy?",
                pauseInfo: "Malapit mo nang i-pause ang panahon ng pagboto. Sigurado ka bang nais mong magpatuloy?",
                publishInfo: "Malapit ka nang gumawa ng publikasyon. Sigurado ka bang gusto mong magpatuloy?",
                ok: "Kumpirmahin",
                ko: "Kanselahin",
                error: "Error sa pag-load ng paglalathala ng balota",
                error_publish: "Error sa paglalathala ng balota",
                error_capacity: "Nabigo ang paggawa ng estilo ng balota: {{message}}",
                error_status: "Error sa pagbabago ng katayuan ng paglalathala ng balota",
                error_preview: "Error sa pag-preview ng publikasyon",
                diff: "Ang pag-render ng lahat ng mga pagbabago ay maaaring magdulot ng pagka-antala sa pahina. Sigurado ka bang nais mong magpatuloy?",
                confirmation: "Ang aksyong gagawin mo ay sensitibo at nangangailangan ng kumpirmasyon. Paki-enter ang iyong password para magpatuloy sa {{action}}.",
            },
            notifications: {
                generated: "Balota nilikha",
                published: "Balota inilathala",
                change_status: "Katayuan ng halalan nabago",
            },
        },
        emailEditor: {
            subject: "Paksa ng Email",
            tabs: {
                plaintext: "Simpleng Teksto",
                richtext: "Mayamang Teksto",
            },
        },
        sendCommunication: {
            send: "Ipadala",
            title: "Ipadala ang Abiso",
            subtitle: "Magpadala ng abiso sa mga botante.",
            sendButton: "Ipadala ang Abiso",
            voters: "Audience",
            schedule: "Iskedyul",
            nowInput: "Ipadala ngayon",
            dateInput: "Petsa at oras para magsimulang magpadala ng mga abiso",
            chooseDate: "Pumili ng petsa",
            languages: "Mga Wika",
            smsMessage: "Mensaheng SMS",
            errorSending: "Error sa pagpapadala ng abiso: {{error}}",
            successSending: "Nakaprograma/naipadala nang matagumpay ang abiso",
            method: "Pamamaraan ng Mga Template",
            type: "Uri ng Komunikasyon",
            alias: "Alias ng Template",
            votersSelection: {
                ALL_USERS: "Lahat",
                NOT_VOTED: "Mga hindi pa nakaboto",
                VOTED: "Mga nakaboto na",
                SELECTED: "Sa {{total}} Napiling {{voters}}",
            },
            path: {
                users: "mga tagagamit",
                voters: "mga botante",
            },
            methodTitle: "Template ng Komunikasyon",
            communicationMethod: {
                EMAIL: "Email",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Mga kredensyal",
                BALLOT_RECEIPT: "Resibo ng Balota",
            },
            email: {
                subject: "Paksa",
            },
        },
        tallysheet: {
            title: "Mga Kahon ng Balota",
            subtitle: "Digitalized na mga kahon ng balota ayon sa channel",
            createTallySuccess: "Na-save ang Tally Sheet",
            createTallyError: "Error sa pag-save ng Tally Sheet",
            createTallyErrorSameKindExists: "Ang Tally Sheet ay umiiral na para sa paligsahang ito na may parehong channel at lugar",
            allFieldsRequired: "Lahat ng mga patlang ay kinakailangan",
            header: {
                change: "Mga Pagbabago na Ipinapublish",
                viewChange: "Tingnan ang Paglalathala",
                history: "Kasaysayan ng Paglalathala",
            },
            action: {
                start: "Simulan ang Halalan",
                stop: "Itigil ang Halalan",
                pause: "Pansamantala",
                generate: "I-regenerate",
                publish: "I-publish ang mga Pagbabago",
                back: "Bumalik",
            },
            inputError: {
                totalValidDoesNotMatch: "Ang mga boto ng kandidato ({{candidateVotesSum}}) ay dapat nasa pagitan ng {{lowerBound}} at {{upperBound}} ayon sa mga panuntunan sa pagboto ng paligsahang ito ({{nonBlankValidVotes}} balidong hindi blangkong boto × hanggang {{maxMarks}} marka bawat balota)",
                censusTooSmall: "Ang kabuuang bilang ng mga boto ({{totalVotes}}) ay hindi dapat mas malaki kaysa sa senso ({{census}})",
                totalInvalidDoesNotMatch: "Ang kabuuang bilang ng mga di-balidong boto ({{totalInvalid}}) ay dapat katumbas ng implicit na di-balidong boto ({{implicitInvalid}}) kasama ang explicit na di-balidong boto ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "Ang kabuuang bilang ng boto ({{totalVotes}}) ay dapat katumbas ng kabuuang balidong boto ({{totalValidVotes}}) kasama ang kabuuang di-balidong boto ({{totalInvalid}})",
                unknownCountingAlgorithm: "Hindi nakikilala ang counting algorithm ng paligsahang ito ({{countingAlgorithm}}), kaya hindi matukoy ang pinapayagang bilang ng mga boto ng kandidato. Suriin ang konpigurasyon ng paligsahan.",
                blankBallotsInconsistent: "Ang Blangkong Balota ay dapat magkaroon ng parehong halaga sa bawat sheet ng paligsahan sa kahong ito",
                blankBallotsOutOfBounds: "Ang halaga ng Blangkong Balota ay wala sa hanay na ipinahihiwatig ng bilang ng blangkong boto bawat paligsahan sa kahong ito",
            },
            label: {
                area: "Lugar",
                channel: "Channel",
                total_votes: "Kabuuang Boto",
                total_valid_votes: "Kabuuang Valid na Boto",
                total_invalid: "Kabuuang Invalid na Boto",
                explicit_invalid: "Tahasang Invalid na Boto",
                implicit_invalid: "Implicit na Invalid na Boto",
                total_blank_votes: "Blankong Boto",
                blank_ballots: "Blangkong Balota",
                census: "Senso",
            },
            common: {
                tallyCeremony: {
                    manage: "Pamahalaan ang Seremonya ng Pagbibilang",
                    view: "Tingnan ang Seremonya ng Pagbibilang",
                    cancel: "Kanselahin ang Seremonya ng Pagbibilang",
                    addKey: "Magdagdag ng Susi ng Pagbibilang",
                },
                edit: "I-edit",
                confirm: "Kumpirmahin",
                back: "Bumalik",
                next: "Susunod",
                cancel: "Bumalik",
                data: "Data",
                title: "Tally Sheet",
                subtitle: "Pag-configure ng Tally Sheet.",
                candidates: "Mga Kandidato",
                save: "I-save",
                approve: "Aprubahan",
                disapprove: "Hindi aprubahan",
                show: "Ipakita",
                add: "Idagdag",
                versions: "Mga bersyon",
                warningDisapprove: "Sigurado ka bang hindi aprubahan ang Tally Sheet na ito?",
                warningApprove: "Sigurado ka bang aprubahan ang Tally Sheet na ito?",
            },
            empty: {
                header: "Walang Tally Sheet Pa.",
                action: "Bumuo ng Tally Sheet",
                add: "Magdagdag",
            },
            breadcrumbSteps: {
                start: "Simulan",
                edit: "I-edit",
                confirm: "Kumpirmahin",
                view: "Tingnan",
            },
            table: {
                area: "Lugar",
                contest: "Paligsahan",
                approvedVersion: "Inaprubahang bersyon",
                latestVersion: "Pinakabagong bersyon",
                labels: "Mga Label",
                annotations: "Mga Anotasyon",
            },
            versionsTable: {
                title: "Mga bersyon ng ballot box",
                version: "Bersyon",
                createdBy: "Ginawa ni",
                reviewedBy: "Na-review ni",
                createdAt: "Ginawa noong",
                reviewedAt: "Na-review noong",
                sourceImport: "Source import",
                importStatus: "Katayuan ng import",
                openImport: "Buksan ang import",
                sourceFile: "Source file",
            },
            message: {
                reviewError: "Error sa pag-review ng tally sheet",
                reviewSuccess: "Na-review ang tally sheet",
            },
        },
        application: {
            import: {
                title: "Mag-import ng Mga Aplikasyon",
                subtitle: "Mag-import ng data ng mga aplikasyon",
                paragraph: "Mag-import ng mga aplikasyon gamit ang isang spreadsheet file sa format na Comma Separated Values (CSV). Mag-download ng halimbawa ng import na CSV file dito.",
                messages: {
                    success: "Matagumpay na na-import ang mga aplikasyon",
                    error: "May error sa pag-import ng mga aplikasyon",
                },
            },
            export: {
                title: "Mag-export ng Mga Aplikasyon",
                subtitle: "Mag-export ng data ng mga aplikasyon",
                button: "I-export",
                paragraph: "Mag-export ng mga aplikasyon gamit ang isang spreadsheet file sa format na Comma Separated Values (CSV).",
                messages: {
                    success: "Matagumpay na na-export ang mga aplikasyon",
                    error: "May error sa pag-export ng mga aplikasyon",
                },
            },
        },
        template: {
            noPermissions: "Wala kang permiso na ma-access ang mga template.",
            title: "Mga Template",
            subtitle: "Listahan ng mga template",
            chooseMethods: "Pumili ng Mga Paraan",
            default: "Gamiton an default na plantilya",
            empty: {
                title: "Walang Template Pa",
                subtitle: "Gusto mo bang lumikha ng isa?",
            },
            action: {
                createOne: "Lumikha ng Template",
            },
            create: {
                title: "Lumikha ng Template",
                success: "Nalikha ang Template",
                error: "Error sa paglikha ng Template",
            },
            update: {
                success: "Na-update ang Template",
                error: "Error sa pag-update ng Template",
            },
            edit: {
                title: "I-edit ang Template",
            },
            form: {
                smsMessage: "Mensaheng SMS",
                document: "Dokumento",
                pdfOptions: "Mga Opsyon sa PDF",
                reportOptions: "Mga Pagpipilian sa Ulat",
                name: "Pangalan ng Template",
                alias: "Alias ng Template",
                type: "Uri ng Komunikasyon",
                communicationMethod: "Pamamaraan ng Komunikasyon",
            },
            type: {
                CREDENTIALS: "Mga Kredensyal",
                INITIALIZATION_REPORT: "Ulat ng Inisyal na Proseso",
                ELECTORAL_RESULTS: "Mga Resulta ng Halalan",
                BALLOT_IMAGES: "Mga Larawan ng Balota",
                BALLOT_RECEIPT: "Resibo ng Balota",
                ACTIVITY_LOGS: "Mga Tala ng Aktibidad",
                MANUAL_VERIFICATION: "Manwal na Pag-verify",
                PARTICIPATION_REPORT: "Ulat ng Pakikilahok",
            },
            method: {
                email: "Email",
                sms: "SMS",
                document: "Dokumento",
            },
            import: {
                title: "Mag-import ng Mga Template",
                subtitle: "Mag-import ng data ng mga template",
                paragraph: "Mag-import ng mga template gamit ang spreadsheet file sa format na Comma Separated Values (CSV). I-download ang isang halimbawa ng import na CSV file dito.",
            },
        },
        materials: {
            createMaterialSuccess: "Nalikha ang suportang materyal",
            createMaterialError: "Error sa paglikha ng suportang materyal",
            updateMaterialSuccess: "Na-update ang suportang materyal",
            updateMaterialError: "Error sa pag-update ng suportang materyal",
            common: {
                title: "Suportang Materyal",
                subtitle: "Ilagay ang data ng suportang materyal.",
            },
            error: {
                title: "Kinakailangan ang pamagat",
                document: "Kinakailangan ang dokumento",
            },
            fields: {
                isHidden: "Nakatago",
                publicUrl: "Publikong URL",
            },
            empty: {
                header: "Wala pang support material",
                action: "Gumawa ng support material",
            },
        },
        widget: {
            logs: "Mga Log",
        },
        settings: {
            countries: {
                title: "Pag-block ng Bansa",
                votingDescription: "Piliin sa ibaba ang mga bansang gusto mong i-block ang pagboto mula sa.",
                enrollmentDescription: " Piliin sa ibaba ang mga bansang gusto mong i-block ang pag-eenroll mula sa.",
                error: {
                    errorSaving: "Error sa pag-save ng listahan ng mga bansa",
                },
            },
            backupRestore: {
                title: "Backup / Ibalik ang Tenant config",
                backup: {
                    label: "Backup",
                    subtitle: "Backup ng Tenant configurations",
                },
                restore: {
                    label: "Ibalik",
                    subtitle: "Ibalik ang Tenant config",
                    title: "Mag-import ng Mga Konfigurasyon ng Tenant",
                    paragraph: "Mag-import ng mga konfigurasyon ng tenant, mga konfigurasyon ng Keycloak, mga role at data ng pahintulot gamit ang zip na folder.",
                    tenantConfigOption: "Mag-import ng Mga Konfigurasyon ng Tenant",
                    keycloakConfigOption: "Mag-import ng Mga Konfigurasyon ng Keycloak",
                    RolesConfigOption: "Mag-import ng Mga Role at Pahintulot na Konfigurasyon",
                },
            },
            previewScreen: {
                label: "Mga Preview",
                noContent: "Walang nahanap na mga preview",
                table: {
                    title: "Mga Panlabas na Preview",
                    description: "Isang rekord ng mga preview ng estilo ng balota na ginawa sa pamamagitan ng mga panlabas na request",
                    requestedBy: "Hiniling ng",
                    document: "Dokumento",
                    url: "URL",
                },
            },
            languages: {
                default: "Default na Wika",
            },
        },
        approvalsScreen: {
            column: {
                status: "Katayuan",
                id: "ID",
                applicantId: "ID ng Aplikante",
                verificationType: "Uri ng Pag-verify",
                createdAt: "Nilikha Noong",
                updatedAt: "Na-update Noong",
                verified_by: "Napatunayan Noong",
            },
            approvalRequest: "Kahilingan para sa Pag-apruba",
            title: "Mga Botante",
            subtitle: "Maghanap ng mga tumutugmang botante",
            approve: {
                body: "Sigurado ka bang nais mong aprubahan ang botanteng ito? Hindi na mababawi ang aksyong ito.",
            },
            reject: {
                label: "Tanggihan ang aplikasyon",
                confirm: "Sigurado ka bang gusto mong tanggihan ang botanteng ito? Ang aksyong ito ay hindi maaaring bawiin.",
                message: "Isulat dito ang dahilan ng pagtanggi",
                rejectReason: "Dahilan ng Pagtanggi",
                messageRequired: "Kinakailangan ang mensahe ng pagtanggi para sa opsyon na 'Iba'",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Kulang na Datos",
                    "no-matching-voter": "Walang Tumutugma na Botante",
                    "voter-already-approved": "Naaprubahan Na",
                    "other": "Iba Pa",
                },
            },
            notifications: {
                approveError: "Error sa pag-apruba ng botante",
                approveSuccess: "Inaprubahan ang botante",
                rejectError: "Error sa pagtanggi ng botante",
                rejectSuccess: "Tinanggihan ang botante",
                VoterApprovedAlready: "Ang botante ay naaprubahan na.",
            },
            export: {
                success: "Matagumpay na natapos ang pag-export ng mga aplikasyon",
                error: "Error sa pag-export ng mga aplikasyon",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Mga Botante",
                enrolledOverseasVoters: "Mga Botanteng Nakarehistro sa Ibang Bansa",
                approvalStatus: "Status ng Aprobasyon: Mga Botanteng Aprobado/Di-Aprobado",
                manuallyApproval: "Mga Botanteng Aprobado/Di-Aprobado Nang Manu-mano",
                automaticallyApproval: "Mga Botanteng Aprobado/Di-Aprobado Nang Awtomatik",
                authenticatedVoters: "Mga Autentikadong Botante",
                invalidUserErrors: "Mga Error sa Hindi Valido ng Gumagamit:",
                invalidPasswordErrors: "Mga Error sa Hindi Valido ng Password:",
            },
            polls: {
                title: "Mga Botohan",
                initializedSystems: "Mga Post na may Inisyal na Sistema",
                votingOpened: "Mga Post na may Bukas na Pagboto",
                votingClosed: "Mga Post na may Saradong Pagboto",
                votingStarted: "Mga Post na may Nagsimula nang Pagboto",
                voterTurnout: "Pagdalo ng mga Botante",
            },
            tally: {
                title: "Pagbibilang",
                activeVotesCounting: "Mga Post na may Aktibong Pagbibilang ng mga Boto",
                generatedERs: "Mga Post na may Nabuo nang ERs",
                transmittedResults: "Mga Post na may Naitagong Resulta",
            },
            testing: {
                title: "Pagsubok",
                testElectionVoterCount: "Bilang ng mga Botante sa Pagsubok na Halalan",
            },
        },
        certificateAuthorities: {
            title: "Mga Sertipiko",
            subtitle: "Mga pinagkakatiwalaang awtoridad sa sertipikasyon (CA) para sa kaganapang ito ng halalan. Ang mga na-import na CA ay ginagamit upang mapatunayan ang mga sertipiko ng botante.",
            importButton: "Mag-import ng mga sertipiko",
            type: {
                root: "Ugat",
                intermediate: "Panggitna",
            },
            expiry: {
                expired: "Nag-expire na",
                expiringSoon: "Malapit nang mag-expire",
                valid: "Wasto",
            },
            columns: {
                commonName: "Karaniwang pangalan",
                type: "Uri",
                issuerCn: "CN ng nagbigay",
                notBefore: "Wasto mula",
                notAfter: "Mag-e-expire",
                fingerprint: "SHA256 Fingerprint",
            },
            importDialog: {
                title: "Mag-import ng mga awtoridad sa sertipikasyon",
                subtitle: "Mag-import ng isa o higit pang CA na sertipiko mula sa PEM file",
                description: "Pumili ng PEM file na naglalaman ng isa o higit pang sertipiko. Sinusuportahan ang mga bundle — ang bawat sertipiko ay ina-import nang paisa-isa.",
                selectFile: "Pumili ng PEM file",
                fileLoaded: "Na-load ang file ({{bytes}} bytes)",
                importButton: "I-import",
            },
            notify: {
                importSuccess: "Na-import ang {{inserted}} sertipiko.",
                importSkipped: "{{count}} nilaktawan (mayroon na).",
                importErrors: "Mga isyu sa pag-import: {{errors}}",
                importError: "Nabigo ang pag-import: {{error}}",
                deleteSuccess: "Nabura ang sertipiko.",
                deleteError: "Error sa pagbura ng sertipiko.",
                exportSuccess: "Matagumpay na na-export ang sertipiko(s).",
                exportError: "Error sa pag-export ng mga sertipiko.",
            },
            exportDialog: {
                title: "I-export ang mga awtoridad sa sertipikasyon",
                description: "Ie-export mo ang {{amount}} sertipiko.",
                all: "lahat",
            },
            deleteDialog: {
                description: "Sigurado ka bang gusto mong burahin ang {{count}} sertipiko?",
            },
            emptyHeader: "Walang mga awtoridad sa sertipikasyon na na-import para sa electoral event na ito.",
            fileReadError: "Nabigo ang pagbasa ng file.",
            viewDialog: {
                title: "Mga detalye ng awtoridad sa sertipikasyon",
                subject: "Paksa",
                issuer: "Nagbigay",
                serialNumber: "Serial number",
                pemContent: "Nilalaman ng PEM",
            },
            confirmDelete: "Burahin ang awtoridad sa sertipikasyon",
            confirmDeleteDescription: 'Sigurado ka bang nais mong burahin ang sertipikong "{{name}}" (fingerprint: {{fingerprint}})?',
        },
    },
};
export default tagalogTranslation;
